import React from "react";
import "./CardCar.css";
import tech from "./images/image3.jpg";

function CardCar() {
  const CardData = [
    {
      id: 1,
      svg: (
        <svg
          className="App-logo"
          height="100px"
          width="100px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-81.28 -81.28 670.56 670.56"
          fill="#000000"
          stroke="#000000"
          stroke-width="4.064"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <circle
              style={{ fill: "#54C0EB" }}
              cx="254"
              cy="254"
              r="254"
            ></circle>{" "}
            <g>
              {" "}
              <circle
                style={{ fill: "#FFFFFF" }}
                cx="130.8"
                cy="262.4"
                r="24.4"
              ></circle>{" "}
              <path
                style={{ fill: "#FFFFFF" }}
                d="M190.4,354.8c0-32.8-26.4-59.2-59.2-59.2l0,0l0,0l0,0l0,0C98.4,295.6,72,322,72,354.8V368 c17.2,6.8,37.2,10.4,59.2,10.4l0,0l0,0l0,0l0,0c22,0,42.4-4,59.2-10.4V354.8z"
              ></path>{" "}
              <circle
                style={{ fill: "#FFFFFF" }}
                cx="377.2"
                cy="262.4"
                r="24.4"
              ></circle>{" "}
              <path
                style={{ fill: "#FFFFFF" }}
                d="M436.4,354.8c0-32.8-26.4-59.2-59.2-59.2l0,0l0,0l0,0l0,0c-32.8,0-59.2,26.4-59.2,59.2V368 c17.2,6.8,37.2,10.4,59.2,10.4l0,0l0,0l0,0l0,0c22,0,42.4-4,59.2-10.4V354.8z"
              ></path>{" "}
              <circle
                style={{ fill: "#FFFFFF" }}
                cx="254"
                cy="84.4"
                r="24.4"
              ></circle>{" "}
              <path
                style={{ fill: "#FFFFFF" }}
                d="M313.2,176.8c0-32.8-26.4-59.2-59.2-59.2l0,0l0,0l0,0l0,0c-32.8,0-59.2,26.4-59.2,59.2V190 c17.2,6.8,37.2,10.4,59.2,10.4l0,0l0,0l0,0l0,0c22,0,42.4-4,59.2-10.4V176.8z"
              ></path>{" "}
            </g>{" "}
            <path
              style={{ fill: "#324A5E" }}
              d="M293.2,287.2l-34.4-26v-36.8c0-5.2-4-9.2-9.2-9.2s-9.2,4-9.2,9.2v36.8l-34.4,26 c-4,3.2-4.8,8.8-1.6,13.2c3.2,4,8.8,4.8,13.2,1.6l32.4-24.4l32.4,24.4c6.8,5.2,11.2,0.8,13.2-1.6 C298.4,296.4,297.6,290.4,293.2,287.2z"
            ></path>{" "}
          </g>
        </svg>
      ),
      title: "Work With Best Team",
     },
    {
      id: 2,
      svg: (
        <svg
          height="100px"
          width="100px"
          viewBox="0 0 146.00 146.00"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <title>001-business</title>
            <rect x="0.5" y="0.5" width="145" height="145" fill="none"></rect>
            <polygon
              points="33.5 112.07 33.5 121.87 28.1 121.87 26.3 121.87 26.3 84.33 33.5 84.33 33.5 89.88 33.5 112.07"
              fill="#ffffff"
              stroke="#000000"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></polygon>
            <polygon
              points="26.3 121.87 26.3 126.81 6.5 126.81 6.5 84.33 26.3 84.33 26.3 121.87"
              fill="#a8cbeb"
            ></polygon>
            <path
              d="M105.17,70.47a0.48,0.48,0,0,1,.42.73l-3.19,5.19,0.09,0.14a15.39,15.39,0,0,0-2.58,1.94L83,89.44l-0.91,0,8.8-13.84a12,12,0,0,1,11.52-5.48Z"
              fill="#ffffff"
              stroke="#000000"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              d="M82.05,89.46l0.91,0,16.94-11a15.39,15.39,0,0,1,2.58-1.94c2.39-1.49,5.93-3,9.42-2.86,3,0.16,7.28,1.66,7.35,3.48a1.86,1.86,0,0,1-.63,1.32L94.27,98c-5.75,2.49-12,5-18.77,7.26-8.3,2.84-16.18,5.06-23.46,6.8H33.5V89.88h4.06l8-7.65A13.61,13.61,0,0,1,55,78.47H80.3a11.82,11.82,0,0,1-7.23,10.82v0.38C75.63,89.59,79.34,89.52,82.05,89.46Z"
              fill="#ffffff"
            ></path>
            <path
              d="M57.1,89.67H72c0.25-.08.6-0.2,1-0.38A11.82,11.82,0,0,0,80.3,78.63a0.16,0.16,0,0,0-.16-0.16H55a13.61,13.61,0,0,0-9.4,3.77l-8,7.65H33.5"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              d="M33.9,112.07h18l0.19,0c7.26-1.73,15.1-3.95,23.37-6.78,6.75-2.31,13-4.78,18.77-7.26l24.35-19.54a1.86,1.86,0,0,0,.63-1.32c-0.07-1.82-4.37-3.32-7.35-3.48-3.49-.19-7,1.37-9.42,2.86a15.39,15.39,0,0,0-2.58,1.94L83,89.44l-0.91,0c-2.71.06-6.42,0.13-9,.2H72.76"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              d="M82.05,89.46l8.8-13.84a12,12,0,0,1,11.52-5.48l2.8,0.33a0.48,0.48,0,0,1,.42.73l-3.19,5.19"
              fill="none"
              stroke="#515f76"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <line
              x1="73.5"
              y1="9.27"
              x2="73.5"
              y2="19.67"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <line
              x1="63.1"
              y1="14.07"
              x2="63.1"
              y2="24.47"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <line
              x1="84.7"
              y1="14.07"
              x2="84.7"
              y2="24.47"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <line
              x1="120.96"
              y1="61.93"
              x2="124.16"
              y2="65.13"
              fill="none"
              stroke="#b8b9ba"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <line
              x1="124.16"
              y1="61.93"
              x2="120.96"
              y2="65.13"
              fill="none"
              stroke="#b8b9ba"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <circle
              cx="137.3"
              cy="69.13"
              r="2"
              fill="none"
              stroke="#b8b9ba"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></circle>
            <circle cx="129.1" cy="81.79" r="1.6" fill="#b8b9ba"></circle>
            <circle cx="44.94" cy="47.5" r="1.6" fill="#b8b9ba"></circle>
            <line
              x1="36"
              y1="131"
              x2="36"
              y2="137"
              fill="none"
              stroke="#b8b9ba"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <line
              x1="39"
              y1="134"
              x2="33"
              y2="134"
              fill="none"
              stroke="#b8b9ba"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <path
              d="M45.7,31.42L48,30.2a0.08,0.08,0,0,1,.12.08L47.7,32.87l2,1.95-2.76.4-1.24,2.5-1.24-2.5-2.6-.38a0.08,0.08,0,0,1,0-.14l1.88-1.84-0.47-2.75Z"
              fill="#a8cbeb"
            ></path>
            <circle cx="41.81" cy="124.48" r="1.6" fill="#b8b9ba"></circle>
            <path
              d="M5.9,85.27v4l14.63,0.59a2.4,2.4,0,0,1,2.17,2.39v35.42h2.4V85.27H5.9Z"
              fill="#d2e1ef"
            ></path>
            <path
              d="M26.3,84.33V126a0.8,0.8,0,0,1-.8.8H6.5"
              fill="none"
              stroke="#515f76"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              d="M6.5,84.33H32.7a0.8,0.8,0,0,1,.8.8v35.94a0.8,0.8,0,0,1-.8.8H26.5"
              fill="none"
              stroke="#515f76"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              d="M73.9,29.15A19.32,19.32,0,1,1,54.58,48.47,19.32,19.32,0,0,1,73.9,29.15ZM88.18,48.47A14.28,14.28,0,1,0,73.9,62.75,14.28,14.28,0,0,0,88.18,48.47Z"
              fill="#ffffff"
            ></path>
            <circle cx="73.9" cy="48.47" r="14.28" fill="#ed9180"></circle>
            <circle
              cx="73.9"
              cy="48.47"
              r="19.32"
              fill="none"
              stroke="#515f76"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></circle>
            <path
              d="M74,48.19a3.24,3.24,0,1,1-3.64,3.22"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              d="M77.68,45a3.67,3.67,0,0,0-7.28,0A3.45,3.45,0,0,0,74,48.19"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <line
              x1="74"
              y1="39"
              x2="74"
              y2="41"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
            <line
              x1="74"
              y1="56"
              x2="74"
              y2="57"
              fill="none"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></line>
          </g>
        </svg>
      ),
      title: "Best Remuneration",
    },
    {
      id: 3,
      svg: (
        <svg
          height="100px"
          width="100px"
          viewBox="-33.71 0 464.955 464.955"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          stroke="#000000"
          stroke-width="2.7897299999999996"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <defs></defs>
            <path
              class="a"
              d="M80.008,197.178a29.04,29.04,0,0,0-2.438,5.185l-1.99,6.48s-10.14-.038-15.473-.038c-11,0-10.974-48.3-4.556-62.667,4.667-10.444,10.444-14,21.222-14,13.084,0,15.993,7.267,15.993,7.267,1.827,3.5,2.672,6.881,3.808,10.721a30.3,30.3,0,0,0,1.825,5.228c1.507,2.956,4.886,4.479,5.732,7.686.34,1.288-.337,3.477-.322,4.808l.12,10.15a20.348,20.348,0,0,1-.806,7.31,18.646,18.646,0,0,1-2.239,4.73,10.972,10.972,0,0,1-4.161,3.6,30.038,30.038,0,0,1-17.807,3.45"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M78.281,196.169a31.032,31.032,0,0,0-2.639,5.662c-.682,2.154-1.327,4.321-1.99,6.481a2.019,2.019,0,0,0,1.4,2.46,2.043,2.043,0,0,0,2.46-1.4q.962-3.132,1.924-6.264c.124-.4.263-.793.409-1.187.087-.214.09-.224.007-.03.05-.116.1-.231.153-.346q.12-.267.246-.531c.459-.962.968-1.9,1.487-2.83a2,2,0,1,0-3.454-2.018Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M91.039,140.415c2.456,4.8,3.1,10.209,5.243,15.113a18.271,18.271,0,0,0,4.059,5.236,7.656,7.656,0,0,1,1.71,2.309,4.91,4.91,0,0,1,0,2.569c-.784,5.373.314,10.885-.213,16.285a15.484,15.484,0,0,1-2.444,6.758,11.353,11.353,0,0,1-4.864,3.829,28.871,28.871,0,0,1-15.614,2.576,2.013,2.013,0,0,0-2,2,2.045,2.045,0,0,0,2,2,32.081,32.081,0,0,0,15.591-2.215,19.689,19.689,0,0,0,6.425-3.8,17.508,17.508,0,0,0,3.9-6.648A22.967,22.967,0,0,0,105.929,178q-.051-4.713-.111-9.425c-.029-2.482.87-4.813-.178-7.205-.967-2.206-2.856-3.671-4.414-5.431-1.97-2.224-2.488-5.525-3.294-8.3a51.672,51.672,0,0,0-3.439-9.243c-1.173-2.292-4.626-.271-3.454,2.019Z"
            ></path>
            <path
              class="c"
              fill="#f4b3b3"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M109.682,312.083c4.371-7.052,7.77-16.6,10.629-23.507a2.321,2.321,0,0,0-.7-2.71c-6.217-4.964-19.454-13.591-19.925-16.806a83.037,83.037,0,0,1-.816-13.775c0-5.334-.654-16.709-1.035-19.11a38.014,38.014,0,0,0-14.522-24.424,86.888,86.888,0,0,0-7.248-5.571,29.673,29.673,0,0,0-8.75-3.792l-26.344,6.3c-7.578,5.714-12.246,13.683-14.881,21.973s-3.375,16.971-4.105,25.594q-2.09,24.678-4.176,49.357c-.319,2.21-.71,4.6-1.205,7.328-.54,2.977,2.931,5.147,5.935,5.95,20.449,5.464,37.508,4.757,57.4-2.08.665-.228,8.834-3.174,12.918-5.007Z"
            ></path>
            <path
              class="a"
              d="M142.214,304.133q-.744-2.4-1.68-4.74a13.256,13.256,0,0,0-2.683-4.574c-2.1-2.094-5.2-2.73-8.114-3.27-3.7-.686-6.034-1.127-9.89-1.842-2.119,5.21-4.536,11.67-7.414,17.409a46.813,46.813,0,0,0,6.929,3.222,52.934,52.934,0,0,1,6.059,2.362c1.928,1,4.5,3.5,6.759,7a8.293,8.293,0,0,0,5.763,3.36c2.274.139,4.871-.762,5.878-2.96s.8-4.76.428-7.156A62.073,62.073,0,0,0,142.214,304.133Z"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M126.192,121.588l5.389,31.176,3.08,17.821c.189,1.093.326,2.211.57,3.293a4.754,4.754,0,0,0,5.08,3.718,27.7,27.7,0,0,0,5.136-1.469l5.217-1.608,42.684-13.158c3.634-1.12,7.289-2.191,10.908-3.362a5,5,0,0,0,3.674-6.114c-.566-3.405-1.176-6.8-1.764-10.2l-4.758-27.523-.921-5.331c-.318-1.84-.4-3.931-1.8-5.322-1.737-1.724-3.85-1.351-5.98-.892l-4.447.956c-19.142,4.113-38.286,8.22-57.456,12.2a6.052,6.052,0,0,0-3.37,1.508,4.732,4.732,0,0,0-1.314,3.774,2.059,2.059,0,0,0,2,2,2.012,2.012,0,0,0,2-2c-.127-1.148.47-1.159,1.472-1.367l3.134-.653q3.263-.681,6.523-1.368,7.365-1.549,14.729-3.115,14-2.975,28-5.978,4.854-1.041,9.708-2.086a6.975,6.975,0,0,1,1.649-.355c.775.06.792.834.9,1.452l.749,4.331q2.2,12.743,4.405,25.483l2.027,11.728a36.765,36.765,0,0,1,.687,3.974c.057.962-.889,1.034-1.855,1.332l-5.217,1.608-40.312,12.427-9.96,3.07-4.979,1.535c-1,.309-2.3,1.142-2.683-.228a24.989,24.989,0,0,1-.429-2.482l-2.75-15.912-5.753-33.277-.112-.65a2.017,2.017,0,0,0-2.46-1.4A2.045,2.045,0,0,0,126.192,121.588Z"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M190.126,110.026q-21.264,4.575-42.545,9.082-6.336,1.34-12.675,2.666a2.046,2.046,0,0,0-1.4,2.461l2.589,14.974,4.1,23.739.95,5.494a2.016,2.016,0,0,0,2.461,1.4q28.344-8.746,56.693-17.483a2.059,2.059,0,0,0,1.4-2.46q-3.366-19.492-6.742-38.985a2.031,2.031,0,0,0-2.46-1.4l-2.375.511c-2.515.541-1.45,4.4,1.064,3.857l2.374-.511-2.46-1.4q3.376,19.491,6.742,38.984l1.4-2.46q-28.348,8.734-56.693,17.483l2.46,1.4-2.589-14.974-4.1-23.739-.95-5.495-1.4,2.46q22.68-4.74,45.331-9.625,4.946-1.059,9.889-2.123C193.705,113.342,192.641,109.485,190.126,110.026Z"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M150.21,225.759q45.734-17.157,91.2-35,12.926-5.073,25.828-10.2a2.062,2.062,0,0,0,1.4-2.46,2.015,2.015,0,0,0-2.461-1.4q-45.39,18.042-91.051,35.4-12.978,4.932-25.979,9.809a2.055,2.055,0,0,0-1.4,2.46,2.017,2.017,0,0,0,2.46,1.4Z"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M129.281,146.464c-2.064,8.219-4.5,16.34-6.589,24.554-.634,2.5,3.223,3.561,3.857,1.063,2.085-8.214,4.525-16.335,6.589-24.554.627-2.5-3.229-3.563-3.857-1.063Z"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M147.492,224.272c-.013,13.386-.1,26.772-.148,40.158q-.015,4.327-.023,8.656c0,2.574,4,2.578,4,0,.012-13.873.1-27.747.149-41.62q.012-3.6.022-7.194c0-2.574-4-2.578-4,0Z"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M121.082,213.537l18.289,7.526a2.013,2.013,0,0,0,2.46-1.4,2.05,2.05,0,0,0-1.4-2.46l-18.288-7.526a2.012,2.012,0,0,0-2.46,1.4,2.049,2.049,0,0,0,1.4,2.46Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M117.632,434.171a97.629,97.629,0,0,0,17.15-.69c3.028-.391,7.273-.921,9.165-3.318,1.154-1.462,1.124-3.238.615-5.848-.391-2.007-3.129-5.54-5.284-6.772-4.043-2.31-6.541-3.616-10.956-6.39l-4.2-3.62a60.026,60.026,0,0,1-22.532,3.665c-1.138,2.906-2.323,5.935-2.323,5.935-2.873,4.925-3.272,11.137-1.124,13.068,1.607,1.443,3.818,1.968,5.94,2.37A97.481,97.481,0,0,0,117.632,434.171Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M86.4,408.8c3.762-.017,6.591.019,10.613-.014l1.419-.012c-.267-6.978-.26-26.283-.206-39.675l-1.278.72c-3.5,2.627-11.052,5.163-18.346,6.905v1.587c-.1,5.131-.677,11.5-1.211,19.815-.23,3.585-.115,7.929,2.755,9.771a8.626,8.626,0,0,0,4.83.913C85.463,408.8,85.937,408.8,86.4,408.8Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M9.4,441.108a7.235,7.235,0,0,1,7.378,7.334c0,4.577-2.854,7.471-7.379,7.471-4.63,0-7.379-2.894-7.379-7.471A7.23,7.23,0,0,1,9.4,441.108Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M74.4,448.127a7.235,7.235,0,0,1,7.379,7.333c0,4.578-2.854,7.471-7.379,7.471-4.63,0-7.379-2.893-7.379-7.471A7.228,7.228,0,0,1,74.4,448.127Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M9.4,443.108c.215,0,.428.016.644.025.626.027-.308-.089.293.038a8.636,8.636,0,0,1,.974.249c.018.006.611.244.25.083.117.052.233.11.347.169q.254.132.5.285c.065.041.638.479.357.241a7.489,7.489,0,0,1,.677.644c-.022-.024.373.438.2.225s.19.274.173.248a8.175,8.175,0,0,1,.507.893c.154.313-.137-.431.055.127.083.239.164.477.228.722a6.417,6.417,0,0,1-.13,3.527c-.052.172-.113.339-.174.507.027-.075.167-.333,0,0-.155.307-.33.592-.5.888-.04.068-.225.309.016,0-.1.13-.212.255-.325.376-.094.1-.192.2-.293.292-.071.066-.537.427-.17.164a7.068,7.068,0,0,1-.709.45c-.15.082-.3.158-.46.229.413-.19-.117.036-.174.055a7.8,7.8,0,0,1-.875.239c-.04.009-.648.113-.214.053-.193.027-.391.041-.585.053a10.447,10.447,0,0,1-1.226,0c-.134-.008-.267-.02-.4-.032-.614-.052.348.1-.236-.037-.3-.071-.6-.129-.9-.221-.171-.053-.338-.112-.505-.176.408.157-.148-.08-.229-.123a6.666,6.666,0,0,1-.783-.49c.351.255-.262-.254-.342-.336-.116-.119-.223-.243-.331-.368.25.287.06.086.011.01a9.221,9.221,0,0,1-.588-1.026c.182.378-.131-.386-.168-.512-.088-.3-.147-.6-.212-.9-.126-.586.009.379-.033-.233-.013-.2-.032-.4-.039-.6a8.87,8.87,0,0,1,.032-1.2c-.035.366.008-.047.028-.139.048-.219.094-.437.156-.652.053-.183.116-.36.178-.54.18-.519-.171.264.1-.212a9.928,9.928,0,0,1,.628-1.037c.2-.274-.309.307.094-.1.174-.178.337-.364.52-.534.092-.085.186-.166.282-.247-.283.238.293-.2.358-.238.135-.085.272-.164.412-.239.067-.036.643-.294.312-.162a5.4,5.4,0,0,1,2.275-.442c2.571-.033,2.579-4.033,0-4A9.368,9.368,0,0,0,.386,445.8c-1.026,3.56,0,7.9,2.99,10.212a10.459,10.459,0,0,0,10.881.747c3.3-1.754,4.875-5.681,4.458-9.293A9.362,9.362,0,0,0,9.4,439.108C6.824,439.075,6.822,443.075,9.4,443.108Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M74.4,450.127c.216,0,.429.016.644.025.627.027-.308-.089.294.037a8.842,8.842,0,0,1,.973.25c.019.006.612.244.251.083.117.052.233.109.347.169.169.088.335.183.5.285.066.041.639.479.358.241a7.624,7.624,0,0,1,.677.644c-.022-.024.373.437.2.224s.19.274.173.249a7.932,7.932,0,0,1,.507.892c.155.314-.137-.431.056.128.082.239.164.477.228.722a6.427,6.427,0,0,1-.131,3.527c-.052.171-.112.339-.174.507.028-.076.168-.333,0,0-.156.306-.331.592-.5.888-.039.067-.225.308.017,0-.1.131-.212.256-.325.377-.095.1-.193.2-.293.292-.071.066-.537.427-.17.163a6.9,6.9,0,0,1-.709.451c-.151.082-.3.157-.46.229.413-.19-.117.035-.174.055a7.863,7.863,0,0,1-.875.239c-.041.008-.648.113-.214.052-.194.027-.391.042-.586.054a10.447,10.447,0,0,1-1.226,0c-.133-.008-.266-.021-.4-.032-.613-.052.349.1-.235-.038-.3-.07-.6-.129-.9-.22-.17-.053-.338-.113-.5-.176.407.156-.148-.08-.229-.123a6.544,6.544,0,0,1-.783-.491c.351.255-.263-.254-.343-.336-.115-.118-.222-.243-.331-.367.25.287.061.085.012.009a9.207,9.207,0,0,1-.588-1.025c.182.378-.131-.386-.169-.512-.088-.3-.146-.6-.211-.9-.127-.586.009.38-.033-.233-.014-.2-.032-.4-.04-.6a8.89,8.89,0,0,1,.033-1.2c-.036.366.008-.046.028-.139.048-.218.094-.436.156-.651.052-.183.116-.361.178-.54.18-.519-.172.263.1-.213a10.14,10.14,0,0,1,.628-1.037c.2-.274-.309.308.093-.1.175-.179.337-.365.521-.534.091-.085.186-.167.281-.247-.283.238.294-.2.359-.239.134-.084.272-.163.412-.238.067-.036.643-.294.311-.163a5.4,5.4,0,0,1,2.275-.441c2.572-.033,2.579-4.033,0-4a9.367,9.367,0,0,0-9.013,6.692c-1.025,3.561,0,7.9,2.99,10.213a10.461,10.461,0,0,0,10.881.746c3.3-1.753,4.875-5.68,4.459-9.293a9.362,9.362,0,0,0-9.317-8.358C71.827,446.094,71.826,450.094,74.4,450.127Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M85.553,419.63c-7.261-4.3-17.365-8.986-23.027-9.935,0-7.218.019-19.372.029-29.847H50.906c-.01,10.533-.03,22.973-.032,30.586A116.629,116.629,0,0,0,8.461,432.089c-2.866,2.26-5.96,5.11-4.541,8.034.253.52,3.93,3.5,6.9,3.539,14.179-9,25.006-15.635,42.592-20.361,4.906,6.4,11.107,16.036,17.241,25.5a3.508,3.508,0,0,0,3.584,1.037c1.289-.331,2.6-.6,3.837-.888a1.722,1.722,0,0,0,1.206-2.318c-1.562-3.887-3.876-8.869-5.43-11.843a86.2,86.2,0,0,0-8.686-13.963c4.76,1,13.325,5.331,17.252,7.953Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M96.944,370.13c-5.226,3.92-19.466,7.638-28.42,8.82C58,380.339,39.778,382.108,22.3,375.03c-6.354-2.573-12.669-8.685-14.667-15.273a21.257,21.257,0,0,1-.7-10.415,14,14,0,0,1,5.495-8.7s16.676-10.061,63.342-10.727S96.944,370.13,96.944,370.13Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M98.737,347.269c-1.841.614-6.678,2-9.661,2.972a103.594,103.594,0,0,1-32.761,4.818c-9.784-.315-17.186-.789-26.263-4.115a38.455,38.455,0,0,1-10.127-6.261c-4.573-3.92-6.86-12.087-3.756-20.09,0,0,1.333-3.583,2.733-7.35a11.868,11.868,0,0,0,3.637,1.649c20.449,5.464,37.508,4.757,57.4-2.08a82.889,82.889,0,0,0,10.38-3.908l19.363-.821c.964-1.555,1.88-3.231,2.754-4.973a46.117,46.117,0,0,0,6.926,3.228,52.934,52.934,0,0,1,6.059,2.362c1.928,1,4.5,3.5,6.759,7a7.068,7.068,0,0,0,1.215,1.333c.624,3.608,1.189,6.878,1.189,6.878a53.623,53.623,0,0,1,.327,12.63c-1.051,18.1-4.307,47.545-7.512,65.557-8.214,4.085-19.17,5.539-27.229,5.035a1.927,1.927,0,0,1-1.276-.408,2.2,2.2,0,0,1-.447-1.5c-.423-9.724-.206-48.638-.141-53.422.022-1.616.175-4.418.1-6.656"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M39.961,206.963c-10.364,7.905-15.785,19.743-18.013,32.346-1.248,7.067-1.734,14.247-2.339,21.39q-.941,11.1-1.88,22.211c-.626,7.4-1.123,14.823-1.878,22.211-.155,1.513-.435,3.021-.689,4.52-.277,1.633-.845,3.4-.485,5.057.564,2.591,2.92,4.361,5.224,5.363a48.324,48.324,0,0,0,9.968,2.587c3.27.639,6.573,1.129,9.889,1.455a86.473,86.473,0,0,0,19.423-.281c11.962-1.531,23.685-5.387,34.685-10.29a2.014,2.014,0,0,0,.717-2.737,2.048,2.048,0,0,0-2.736-.717,128.073,128.073,0,0,1-27.577,8.911,89.346,89.346,0,0,1-37.23-1.033c-2.537-.59-5.644-1-7.628-2.86a2.139,2.139,0,0,1-.793-2.1c.26-1.619.565-3.23.818-4.85,1.071-6.851,1.332-13.885,1.917-20.794q.9-10.612,1.8-21.224c.583-6.895,1.04-13.818,1.894-20.686,1.64-13.182,5.965-26.657,16.936-35.025a2.066,2.066,0,0,0,.718-2.736,2.014,2.014,0,0,0-2.737-.718Z"
            ></path>
            <path
              class="e"
              fill="#a98a75"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M65.7,121.116a40.7,40.7,0,0,1,5.491.493,30.364,30.364,0,0,1,20.257,13.519,27.554,27.554,0,0,1,2.564,5.673l-.679,1.485c-1.4,3.06-5.574,7.919-8.2,11.131-2.22,2.713-7.872,8.267-10.974,9.621a7.129,7.129,0,0,0-3.521-1.538c-3.039-.451-4.565.652-5.256,1.335-2.065,2.043-2.759,6.353-2.119,9.215a14.021,14.021,0,0,0,3.19,6.7c-.994,5.6-2.977,11.43-2.4,17.152a14.269,14.269,0,0,0,4.026,8.875c1.409,1.355-4.061,3.97-6.669,4.851-2.637.833-5.642,1.443-8.169.731-10.536,8.123-18.517,6.282-22.359,2.561-1.32-1.279-3.112-5.961-2.081-12.385.987-6.156.393-13.2-1.717-22.378-.994-4.325-4.009-11.183-4.389-16.079A35.62,35.62,0,0,1,25.7,143.355c5.772-11.917,18.363-20.618,31.87-22.024,2.063-.182,4.243-.266,6.3-.249C64.481,121.087,65.091,121.1,65.7,121.116Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M276.922,385.054c.095-.1.19-.194.284-.293,9.924-10.773,30.852-17.076,13.341-35.44a49.746,49.746,0,0,1-11.094,2.363c-3.47.332-7.349.151-9.945-2.111-3.733,13.34-20.932,17.428-24.021,30.946-1,4.411,2.181,9.445,7.262,10.634C261.214,393.132,270.68,391.361,276.922,385.054Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M215.371,371.42c-2.5-1.44-4.682-4.012-4.3-7.388.742-6.528,5.722-11.951,13.965-16.9,5.006-3,9.857-6.731,12.539-11.831a9.781,9.781,0,0,0,2.176.972,27.583,27.583,0,0,0,15.738.431c1.229,3.108,2.769,7.01,2.769,7.01,4.774,7.945-4.923,14.049-10.509,17.52-4.911,2.662-10.994,6.74-16.422,9.491-5.176,2.623-10.755,3.227-15.249,1.066C215.842,371.679,215.605,371.554,215.371,371.42Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M308.118,277.066c4.232,1.51,12.558,1.552,17.931.377a76.757,76.757,0,0,0,10.916-3.1c6.942-2.613,14.846-5.528,21.744-8.257,10.475-4.144,17.344-6.771,22.835-17.126,4.242-8,5.449-20.25,6.681-29.1,2.267-16.279,3.879-32.661,5.138-49.047.815-10.619,1.106-16.128.966-21.025-.141-4.947-3.358-13.321-11.936-16.179l-18.62-5.464-70,143.667Z"
            ></path>
            <path
              class="f"
              fill="#a0a0a0"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M297.737,238.292a81.324,81.324,0,0,0,6.614,13.292c1.611,2.357,4.87,8.563,8.46,13.858l-1.226.513a62.252,62.252,0,0,0-6.9,3.308c-2.847,1.546-5.46,4.192-5.472,7.431-.082,21.736-.406,47.263-2.535,68.392a2.686,2.686,0,0,1-1.14,1.77,21.054,21.054,0,0,1-4.81,2.4,49.652,49.652,0,0,1-11.275,2.425c-3.628.347-7.7.133-10.291-2.434-2.615-2.593-2.767-6.68-2.888-10.36-.058-1.8-.128-3.784-.207-5.922l-8.106,2.945a27.568,27.568,0,0,1-18.208.362,7.385,7.385,0,0,1-3.048-1.676,8.379,8.379,0,0,1-1.734-4.6c-3.421-21.805-4.263-43.933-5.106-65.993a154.052,154.052,0,0,1,.166-16.337c.187-2.783.471-5.556.9-8.32a22.885,22.885,0,0,1,4.939-10.025,31.74,31.74,0,0,1,7.928-6.478l2.871-1.612c19.734-7.228,33.448-11.386,47-14.3-.587,7.548-.644,15.4.607,21.1A70.966,70.966,0,0,0,297.737,238.292Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M316.947,351.823a7.352,7.352,0,0,0-8.817,5.831c-.915,4.56,1.35,8.013,5.857,8.917,4.613.926,7.93-1.407,8.845-5.967A7.346,7.346,0,0,0,316.947,351.823Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M388.036,349.829a7.352,7.352,0,0,0-7.5,7.444c0,4.651,2.894,7.594,7.492,7.6,4.7,0,7.5-2.933,7.5-7.584A7.345,7.345,0,0,0,388.036,349.829Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M317.478,349.9a9.485,9.485,0,0,0-10.362,4.717,9.945,9.945,0,0,0,.948,10.892,10.572,10.572,0,0,0,10.512,2.9c3.827-1.141,6.012-4.764,6.373-8.59a9.417,9.417,0,0,0-7.471-9.917,2.047,2.047,0,0,0-2.46,1.4,2.02,2.02,0,0,0,1.4,2.46,5.525,5.525,0,0,1,3.415,1.953c.039.043.226.3.04.044q.168.229.316.473a6.479,6.479,0,0,1,.438.838c-.161-.379.06.2.07.23.048.151.092.3.131.457s.068.31.1.466c.039.239.044.252.013.038.014.129.025.257.032.386.019.327,0,.65-.007.978-.01.6.086-.34-.026.259-.025.135-.051.27-.08.4a10.347,10.347,0,0,1-.328,1.169c-.042.122-.087.244-.134.364.139-.352-.155.311-.189.375-.141.267-.306.513-.465.768-.29.465.254-.249-.111.148-.116.126-.226.256-.347.377s-.7.582-.362.343c-.279.194-.567.35-.86.52-.458.265.363-.1-.144.067-.108.037-.215.077-.325.111a6.7,6.7,0,0,1-1.029.236c.386-.056.065-.011-.012-.009-.188,0-.375.022-.563.024a8.441,8.441,0,0,1-1.179-.067c.395.052-.289-.06-.293-.061-.2-.041-.4-.087-.6-.139-.318-.084-.628-.189-.937-.3-.557-.2.293.18-.215-.1-.107-.059-.218-.11-.326-.168q-.237-.131-.464-.276c-.1-.064-.2-.13-.292-.2.149.121.168.136.059.047a6.606,6.606,0,0,1-.683-.645s-.351-.418-.169-.185-.141-.21-.139-.207c-.155-.236-.282-.485-.414-.734-.251-.471.093.364-.061-.152-.067-.222-.144-.439-.2-.665-.029-.115-.047-.232-.076-.346-.14-.547.009.389-.033-.184-.023-.314-.042-.625-.037-.939q0-.292.028-.585c0-.018.088-.661.025-.272a8.7,8.7,0,0,1,.271-1.183,5.5,5.5,0,0,1,2.278-2.959c.108-.067.218-.13.329-.19.068-.037.734-.326.393-.2a7.435,7.435,0,0,1,1.123-.326c.03-.006.659-.077.259-.046.2-.016.407-.029.612-.032s.418,0,.626.017c.142.009.284.023.425.04-.175-.018-.136-.007.115.032a2.054,2.054,0,0,0,2.46-1.4A2.018,2.018,0,0,0,317.478,349.9Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M388.036,347.829a9.487,9.487,0,0,0-9.132,6.78,9.859,9.859,0,0,0,3.066,10.334,10.6,10.6,0,0,0,11.022.764c3.347-1.773,4.892-5.772,4.473-9.418a9.475,9.475,0,0,0-9.429-8.46c-2.575-.036-2.577,3.964,0,4,.218,0,.434.015.652.025.632.029-.3-.088.3.039a9.113,9.113,0,0,1,.988.253c.012,0,.615.243.261.086.119.053.237.111.352.171q.258.135.5.289c.064.04.641.476.37.248a7.584,7.584,0,0,1,.688.653c-.025-.027.378.441.21.231s.2.285.179.256a7.868,7.868,0,0,1,.515.907c.157.318-.136-.429.061.138.084.244.167.486.232.736a6.681,6.681,0,0,1-.124,3.61c-.052.174-.114.343-.173.515-.026.076-.161.341,0,.012a7.565,7.565,0,0,1-.5.9c-.062.094-.127.187-.195.277.275-.366-.072.064-.116.111-.095.1-.193.2-.295.3-.068.064-.535.432-.175.17a6.431,6.431,0,0,1-.72.457c-.152.084-.309.161-.468.233.407-.184-.138.041-.188.058a7.762,7.762,0,0,1-.9.242c-.031.007-.653.109-.237.054-.2.027-.4.042-.606.054a10.571,10.571,0,0,1-1.246,0c-.133-.008-.266-.021-.4-.033-.61-.053.346.1-.236-.039-.3-.074-.6-.132-.9-.225q-.258-.081-.509-.18c.4.157-.161-.087-.239-.129a6.849,6.849,0,0,1-.8-.5c.337.244-.279-.266-.359-.348s-.57-.715-.338-.37a9.261,9.261,0,0,1-.607-1.043c-.036-.07-.13-.349-.007-.012-.062-.171-.123-.342-.176-.516-.092-.3-.152-.606-.221-.913-.133-.59.01.373-.037-.245-.016-.2-.033-.406-.041-.609a8.929,8.929,0,0,1,.033-1.213c-.036.359.01-.057.03-.147.049-.222.095-.442.158-.66.054-.185.118-.365.181-.547.183-.523-.169.259.1-.223a9.989,9.989,0,0,1,.637-1.053c.2-.278-.308.307.1-.113.177-.182.342-.371.529-.544.093-.086.189-.169.286-.251-.27.227.306-.209.37-.249q.205-.129.419-.243c.065-.035.641-.3.325-.17a5.53,5.53,0,0,1,2.327-.45C390.608,351.8,390.615,347.8,388.036,347.829Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M308.277,324.221c7.643-2.829,17.919-5.545,23.926-5.74.009-7.615-.011-34.66-.011-42.564V264.638h13.026l.048,6.594c-.02,8.106-.162,41.148-.167,47.984A118.486,118.486,0,0,1,387.613,341.1c2.911,2.3,6.052,5.2,4.607,8.167-.257.528-4,3.55-7.008,3.59-14.49-9.214-25.534-15.992-43.6-20.817-6.866,5.6-13.508,12.638-21.328,21.109-.848.918-2.653.858-3.778.315-1.217-.587-2.469-1.119-3.644-1.65a1.779,1.779,0,0,1-.739-2.551,97.532,97.532,0,0,1,7.456-10.973c4.352-5.458,5.273-6.734,7.561-9.059-5.009.431-12.983,2.81-17.385,4.718Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M229.31,85.768a70.564,70.564,0,0,0,13.572,9.058q-.254-2.145-.513-4.289a10.282,10.282,0,0,1,.247-5.1c.648-1.595,2.449-2.862,4.076-2.3,1.431.5,2.111,2.087,2.628,3.51l2.082,5.737c2.36,6.5,5.3,13.9,2.89,21.559q.787.944,1.571,1.851-6.453,5.487-12.907,10.973c-1.441-2.346-2.829-4.685-4.18-6.979a67.026,67.026,0,0,1-27.4-17.808A11.051,11.051,0,0,1,208.8,98a4.284,4.284,0,0,1,.958-4.424,7.879,7.879,0,0,1-1.506-3.586,2.706,2.706,0,0,1,2.028-2.936,4.556,4.556,0,0,1,6.918-4.84c1.059-1.746,3.543-2.134,5.469-1.454a15.5,15.5,0,0,1,4.955,3.527Q228.452,85.04,229.31,85.768Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M245.094,96.559c-.276-2.292-.595-4.585-.824-6.882-.138-1.39-.439-3.839,1.175-4.557,1.345-.6,1.964,2.11,2.266,2.941q1.131,3.117,2.264,6.234c1.428,3.925,2.9,7.973,3.167,12.176a21.421,21.421,0,0,1-.641,6.481c-.349,1.468.1,2.079,1.011,3.16.827.976,1.667,1.941,2.509,2.9,1.7,1.941,4.518-.9,2.828-2.828-1.058-1.211-2.11-2.427-3.143-3.659l.514,1.946c2.247-7.46-.04-14.8-2.6-21.838q-.987-2.708-1.968-5.418a13.232,13.232,0,0,0-2.3-4.637c-2.459-2.685-6.543-1.571-8.224,1.38a9.768,9.768,0,0,0-.826,5.931c.24,2.224.532,4.444.8,6.666a2.063,2.063,0,0,0,2,2,2.013,2.013,0,0,0,2-2Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M240.832,91.439a81.976,81.976,0,0,1-13.019-9.672c-1.854-1.631-3.9-3.062-6.422-3.3a6.326,6.326,0,0,0-5.924,2.73l2.737-.718a6.563,6.563,0,0,0-9.856,7.1l1.4-2.46a4.556,4.556,0,0,0-3.394,3.673c-.4,2.118.58,4.045,1.676,5.787l.313-2.424c-2.967,2.932-1.7,7.135.584,10.016a50.8,50.8,0,0,0,8.425,8.083,68.754,68.754,0,0,0,20.9,11.46l-1.195-.919c1.774,3.009,3.563,6.009,5.415,8.97,1.362,2.178,4.825.173,3.454-2.018q-2.031-3.249-3.982-6.548a14.257,14.257,0,0,0-1.746-2.828c-.736-.736-2.195-.952-3.153-1.313a62.544,62.544,0,0,1-11.155-5.635,64.537,64.537,0,0,1-9.981-7.684,36.521,36.521,0,0,1-4.079-4.31c-.906-1.194-1.958-3.157-.654-4.445a2.032,2.032,0,0,0,.313-2.424c-.5-.791-2.084-3.283-.673-3.584a2.042,2.042,0,0,0,1.4-2.46,2.592,2.592,0,0,1,3.98-2.581,2.044,2.044,0,0,0,2.736-.717c.83-1.228,2.761-.809,3.842-.241,1.815.953,3.238,2.573,4.774,3.9a74.677,74.677,0,0,0,11.276,8.017c2.231,1.293,4.248-2.163,2.019-3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M234.659,94.7l-6.415,7.929a2.168,2.168,0,0,0-.585,1.415,2,2,0,0,0,3.414,1.414l6.415-7.929a2.161,2.161,0,0,0,.586-1.414,2,2,0,0,0-3.415-1.415Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M234.832,95.383c-2.89-2.506-5.927-4.84-8.755-7.417a2,2,0,0,0-2.828,2.829c2.828,2.576,5.865,4.911,8.755,7.416a2,2,0,1,0,2.828-2.828Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M231.31,100.512q-8.562-6.8-17.305-13.368a2.014,2.014,0,0,0-2.737.717,2.05,2.05,0,0,0,.718,2.737q8.334,6.26,16.5,12.742a2.064,2.064,0,0,0,2.829,0,2.014,2.014,0,0,0,0-2.828Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M351.068,47.412a4.694,4.694,0,0,1,3.386-.758,4.239,4.239,0,0,1,3.526,2.413c1.031,2.254.533,6.125-.6,8.43a12.286,12.286,0,0,1-4.622,5.48,9.035,9.035,0,0,1-4.416,1.041c-.154.312-.313.638-.313.638-.56,1.179-1.888,3.243-1.888,3.243a41.2,41.2,0,0,1-4.508,5.693c.019,2.462.059,5.707.093,7.055a4.61,4.61,0,0,0,1.021,2.762c-3.121,6.028-6.7,12.367-10.6,18.848,6.971.526-7.063,1.6-10.4,1.775-3.493.186-6.719.144-9.857-2.232-1.169-.885-3.836-4.06-3.186-3.792.052-1.6.13-3.006.24-4.136.3-3.06.724-6.283,1.321-9.849l.421-1.886a25.273,25.273,0,0,1-8.267-4.608c-5.194-4.219-7.471-10.893-8.308-18.279-.483-4.259-.907-8.889-1.534-13.514,0,0-3.943-20.931,23.422-20.931C353.329,24.805,351.068,47.412,351.068,47.412Z"
            ></path>
            <path
              class="g"
              fill="#85807f"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M361.486,38.468c.067,1.917.176,12.069.243,13.987.149,4.3.27,8.758-1.421,12.711-2.569,6-6.3,10.726-14.643,12.322a10.325,10.325,0,0,1-3.133.125l-.858-.128c-.016-1.273-.029-2.677-.037-3.889a41.747,41.747,0,0,0,4.5-5.7s1.328-2.064,1.888-3.243c0,0,.121-.263.3-.638a9.04,9.04,0,0,0,4.432-1.041,12.286,12.286,0,0,0,4.622-5.48c1.133-2.3,1.631-6.176.6-8.43a4.239,4.239,0,0,0-3.526-2.413,4.694,4.694,0,0,0-3.386.758l-8.207-1.04a6.362,6.362,0,0,1-4.707-1.321,18.878,18.878,0,0,1-3.465-3.613l-3.827-4.777a9.111,9.111,0,0,1-11.347-1.374A8.491,8.491,0,0,1,306.75,34.2a35.092,35.092,0,0,1-9.8,2.529s-2.53.517-5.392,1.1a46.709,46.709,0,0,1,.5-8.212,33.968,33.968,0,0,1,6.612-15.28C304.5,7.236,313.317,2.828,324.351,2.1c7.7-.507,15.442.992,24.01,7.738,6.841,4.645,9.827,10.1,11.726,17.125a59.111,59.111,0,0,1,1.4,11.5"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M339.632,73.58c.018,2.119.038,4.238.079,6.356a8.138,8.138,0,0,0,.373,2.71,8.72,8.72,0,0,0,2.041,3.129c1.336,1.319,2.946,2.428,4.4,3.616a2.057,2.057,0,0,0,2.828,0,2.014,2.014,0,0,0,0-2.828c-1.42-1.159-2.939-2.252-4.284-3.5a5.758,5.758,0,0,1-.706-.8c.042.057-.245-.39-.3-.49-.018-.031-.276-.582-.122-.2a6.215,6.215,0,0,1-.195-.654c-.113-.395-.027.323-.014-.118.01-.344-.018-.7-.025-1.041-.037-2.063-.058-4.126-.075-6.189a2,2,0,1,0-4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M359.486,38.468c.152,4.627.1,9.259.239,13.886.126,4.165.332,8.479-1.4,12.38a19.986,19.986,0,0,1-5.043,7.237,15.166,15.166,0,0,1-10.753,3.642,2.012,2.012,0,0,0-2,2,2.048,2.048,0,0,0,2,2c3.87.439,8.372-1.158,11.569-3.283a20.72,20.72,0,0,0,6.731-7.627,26.186,26.186,0,0,0,2.977-12.669c0-2.933-.132-5.874-.176-8.808-.043-2.919-.051-5.841-.147-8.758-.085-2.568-4.085-2.579-4,0Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M309.142,125.381c-.355-8.376-.68-19.984-.442-27.376a17.53,17.53,0,0,0,3.186,3.8c3.138,2.376,6.364,2.418,9.857,2.232,1.714-.091,6.247-.418,9.309-.785l.525-.047c-6.4,10.555-13.64,21.466-21.176,32l-.608.851-.075-.535C309.605,134.709,309.367,130.7,309.142,125.381Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M382.774,161.033q-.252-2.572-.563-5.186c-.578-4.88-3.408-23.916-4.226-28.44-1.408-7.8-3.435-15.473-7.624-22.406-4.221-6.987-10.964-12.454-18.567-16.54l-.178-.2a28.1,28.1,0,0,0-3.267-3.375c-1.387-1.094-2.841-2.386-4.469-3.691-8.411,16.64-20.513,35.876-33.479,54.007l-.608.851-.075-.535c-.331-2.363-1.716-31.992-.778-41.647.334-3.436.831-7.077,1.547-11.185-5.409,1.6-8.614,3.56-12.638,4.78-6.955,2.1-14.861,5-19.477,9.375-5.665,5.365-10.9,15.1-13.767,24.257a85.663,85.663,0,0,1-5.658-7.926l-18.254,15.518a1.947,1.947,0,0,0-.607,2.894,133.016,133.016,0,0,0,6.865,13.077c3.262,5.455,7.388,11.033,13.486,12.823,7.8,2.292,16.251-2.608,21.008-9.122.182.464.37.928.559,1.392,3.228,7.956,3.437,23.658,2.825,30.1a42.005,42.005,0,0,1-2.164,10.2c-2.015,5.8-7.614,10.177-9.31,11.27-9.014,6.043-19.834,12.656-28.986,19.879-.366.289-.828.662-.74,1.12,0,.017.007.033.012.049l.759-.29c20.965-7.746,35.205-12.111,49.272-15.135-.587,7.548-.644,15.4.607,21.1,1.31,5.97,6.663,18.573,10.072,23.542,2.494,3.649,8.936,16.521,14.444,20.96,7.89-1.993,10.337-5.725,13.306-7.61,4-2.54,8.3-3.405,11.892-4.8a155.322,155.322,0,0,0,17.832-8.127c5.242-3,13.052-11.982,9.787-26.411l3.861-20.308c-.139-3.43-.481-6.8-.882-9.9a29.441,29.441,0,0,0,3.177-2.187,13.979,13.979,0,0,0,4.159-5.146,21.1,21.1,0,0,0,1.925-8.486C383.739,173.251,383.381,167.208,382.774,161.033Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M381.861,135.531a15.814,15.814,0,0,1,9.858,10.695c1.123,3.856.664,8.4.454,12.552-.79,15.656-2.311,31.322-4.134,46.889q-1.288,11.005-2.876,21.98c-.925,6.393-1.954,13.134-4.717,19.036a27.587,27.587,0,0,1-10.606,12.164c-5.1,3.088-10.919,5.044-16.46,7.175-3.605,1.386-7.221,2.742-10.837,4.1-3.592,1.345-7.159,2.792-10.846,3.857-6.326,1.827-12.807,2.873-19.393,2a18.9,18.9,0,0,1-3.654-.836c-2.44-.838-3.488,3.024-1.064,3.857a29.579,29.579,0,0,0,9.07,1.267,44.326,44.326,0,0,0,9.925-.89c7.9-1.685,15.358-4.753,22.894-7.6,6.452-2.438,13.07-4.737,19.27-7.781a31.527,31.527,0,0,0,12.717-10.963c3.791-5.748,5.543-12.459,6.736-19.165,1.3-7.305,2.168-14.716,3.1-22.075,2.108-16.7,3.7-33.5,4.727-50.3.287-4.715.842-9.787-.007-14.47a20.382,20.382,0,0,0-8.76-13.292,19.829,19.829,0,0,0-4.331-2.049c-2.438-.841-3.486,3.022-1.063,3.858Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M70.192,244.015c.47,10.555.546,21.162,1.787,31.666.61,5.16,1.328,10.586,4.339,14.966a40.771,40.771,0,0,0,9.288,9.144,144.4,144.4,0,0,0,17.372,10.849c2.254,1.247,4.274-2.206,2.019-3.454A163.3,163.3,0,0,1,89.625,297.8a42.768,42.768,0,0,1-9.195-8.262c-2.954-3.79-3.789-8.521-4.369-13.181-.647-5.2-.956-10.441-1.207-15.673-.265-5.554-.415-11.113-.662-16.668-.114-2.563-4.115-2.578-4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M98.205,345.34c-12.286,4.054-24.775,7.468-37.8,7.739a97.514,97.514,0,0,1-20.756-1.508,51.291,51.291,0,0,1-9.564-2.744,33.526,33.526,0,0,1-8.22-5.114c-5.5-4.516-6.157-12.242-3.772-18.588a2.017,2.017,0,0,0-1.4-2.46,2.042,2.042,0,0,0-2.46,1.4c-2.437,6.485-1.994,14.335,2.333,19.945a27.6,27.6,0,0,0,7.52,6.152,38.337,38.337,0,0,0,9.845,4.152c7.133,2.025,14.537,2.493,21.913,2.734A100.3,100.3,0,0,0,79.2,354.871,179.951,179.951,0,0,0,99.268,349.2c2.434-.8,1.391-4.667-1.063-3.858Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M132.656,328.44c.9,5.463.352,11.081-.033,16.57-.33,4.709-.732,9.414-1.178,14.114-.98,10.34-2.149,20.667-3.571,30.956-.715,5.174-1.492,10.341-2.4,15.485l.919-1.2a48.6,48.6,0,0,1-13.6,4.1,58.426,58.426,0,0,1-6.8.694q-1.588.071-3.181.058c-.755-.007-2.3.208-2.91-.228l.717.717c-.215-.281-.17-.407-.19-.883-.012-.286-.021-.573-.03-.859-.024-.739-.041-1.478-.057-2.216q-.057-2.707-.081-5.415c-.047-4.485-.062-8.97-.068-13.456q-.018-13.071.07-26.144c.025-3.86.246-7.744.141-11.6-.071-2.569-4.071-2.579-4,0,.1,3.706-.113,7.435-.138,11.146q-.043,6.287-.06,12.574c-.029,9.972-.056,19.946.085,29.917.023,1.68.052,3.36.1,5.039a12.4,12.4,0,0,0,.219,2.746c.55,2.07,2.354,2.516,4.243,2.606a60.821,60.821,0,0,0,20.972-2.715A48.845,48.845,0,0,0,127,408.489a4.27,4.27,0,0,0,2.131-1.383,7.233,7.233,0,0,0,.525-2.337c.523-3.058,1-6.123,1.45-9.193,1.015-6.925,1.9-13.87,2.7-20.824s1.517-13.937,2.123-20.92a190.826,190.826,0,0,0,1.187-20.1,44.574,44.574,0,0,0-.6-6.357,2.016,2.016,0,0,0-2.46-1.4,2.047,2.047,0,0,0-1.4,2.46Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M127.313,412.88c2.363,1.48,4.765,2.893,7.193,4.263,2.073,1.169,4.224,2.151,5.843,3.936a8.637,8.637,0,0,1,2.548,5.933c.022,2.119-1.624,3.03-3.472,3.584a39.984,39.984,0,0,1-7.516,1.212,97.571,97.571,0,0,1-9.864.474,79.879,79.879,0,0,1-19.229-2.027,10.659,10.659,0,0,1-2-.673,7.814,7.814,0,0,1-1.366-.868,4.086,4.086,0,0,1-.662-2.435,15.581,15.581,0,0,1,2.207-8.137c1.273-2.241-2.182-4.259-3.454-2.019a20.467,20.467,0,0,0-2.748,9.176c-.1,2.482.406,5.128,2.448,6.732,2.808,2.207,6.694,2.6,10.112,3.113a102.294,102.294,0,0,0,11.564,1.08,97.943,97.943,0,0,0,11.556-.284,55.123,55.123,0,0,0,9.516-1.345c2.722-.724,5.443-2.152,6.492-4.927a10.474,10.474,0,0,0-.914-8.164,17.353,17.353,0,0,0-7.071-6.706c-3.084-1.742-6.158-3.491-9.161-5.372-2.187-1.371-4.2,2.089-2.018,3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M97.009,406.782q-6.225.046-12.453.026c-1.693-.006-3.45-.1-4.361-1.724a9.224,9.224,0,0,1-.881-4.358c-.071-4.032.45-8.115.733-12.135.241-3.424.48-6.851.551-10.284.053-2.575-3.947-2.575-4,0-.134,6.452-.764,12.891-1.179,19.328-.2,3.032-.254,6.253,1.107,9.05,1.587,3.261,4.862,4.131,8.238,4.122,4.082-.012,8.164.006,12.245-.025,2.573-.02,2.579-4.02,0-4Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M80.831,408.783c-1.093,1.481-2.18,2.966-3.183,4.51a2,2,0,0,0,3.454,2.019c1-1.544,2.09-3.029,3.183-4.51a2.01,2.01,0,0,0,.2-1.541,2.038,2.038,0,0,0-.919-1.2,2.017,2.017,0,0,0-1.541-.2l-.478.2a2.014,2.014,0,0,0-.717.718Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M76.05,162.089a9.533,9.533,0,0,0-8.633-2.5,7.233,7.233,0,0,0-5.024,4.073,15.287,15.287,0,0,0,1.84,15.51,11.768,11.768,0,0,0,8.819,4.817c2.572.151,2.563-3.85,0-4-5.117-.3-8.184-5.938-8.011-10.661a9.941,9.941,0,0,1,.736-3.5,5.7,5.7,0,0,1,.678-1.207,4.677,4.677,0,0,1,.531-.55c.332-.313-.353.205.09-.069a4.337,4.337,0,0,1,2.832-.583,5.072,5.072,0,0,1,3.313,1.5c1.785,1.862,4.611-.969,2.829-2.828Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M97.647,156.9c.756,1.443,1.3,5.024-1.108,5.87-3.285.7-4.44-3.525-3.8-5.77C93.268,155.163,95.769,153.9,97.647,156.9Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M101.783,175.424c-.069.031-.137.06-.207.09l.478-.2a8.242,8.242,0,0,1-2.063.586l.532-.072a6.675,6.675,0,0,1-1.573,0,2,2,0,0,0-1.415.586,2,2,0,0,0,0,2.828l.405.313a1.991,1.991,0,0,0,1.01.273,6.688,6.688,0,0,0,1.549,0,10.161,10.161,0,0,0,1.552-.282,13.576,13.576,0,0,0,1.751-.669,2,2,0,0,0,.919-1.195,2.043,2.043,0,0,0-.2-1.541,2.017,2.017,0,0,0-1.2-.919l-.532-.072a1.987,1.987,0,0,0-1.009.273Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M51.656,209.062c-4.076,2.992-9.387,5.9-14.621,4.828a9.865,9.865,0,0,1-4.2-1.9,2.634,2.634,0,0,1-1.029-1.206,10.516,10.516,0,0,1-.953-2.817c-.638-2.932-.223-5.81.131-8.743a43.368,43.368,0,0,0,.161-8.168,74.237,74.237,0,0,0-3.508-18.068,84.694,84.694,0,0,1-2.588-8.671,32.216,32.216,0,0,1-.432-8.953,31.773,31.773,0,0,1,6.421-16.918,39.067,39.067,0,0,1,28.778-15.273c7.3-.386,14.493.212,20.84,4.109a29.314,29.314,0,0,1,6.974,6.017,27.377,27.377,0,0,1,4.782,8.938c.86,2.406,4.726,1.369,3.857-1.064a32.528,32.528,0,0,0-4.568-9.151,34.016,34.016,0,0,0-6.828-6.708,33.259,33.259,0,0,0-19.03-6.195,47.362,47.362,0,0,0-19.624,3.016A44.008,44.008,0,0,0,30.981,132.38a36.842,36.842,0,0,0-9.41,16.638,38.35,38.35,0,0,0,.613,20.121c.907,2.994,2.048,5.925,2.823,8.958a76.893,76.893,0,0,1,1.882,10.21,48.873,48.873,0,0,1,.256,9.241c-.236,3.118-.874,6.111-.508,9.257.294,2.539.915,5.5,2.729,7.429a12.674,12.674,0,0,0,5.624,3.271c6.59,1.921,13.44-1.139,18.685-4.989a2.061,2.061,0,0,0,.717-2.737,2.014,2.014,0,0,0-2.736-.717Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M47.352,208.194c2.405,3.537,6.088,4.87,10.264,4.335a24.937,24.937,0,0,0,9.261-3.2c2.373-1.379,4.739-3.693,2.328-6.252-2.739-2.907-3.44-6.915-3.212-10.779a68.814,68.814,0,0,1,1.944-10.73c.555-2.509-3.3-3.58-3.857-1.064-1.713,7.739-4.146,16.76.959,23.785a15.773,15.773,0,0,0,1.066,1.326q.267.3.554.572a1.4,1.4,0,0,1-.33-1.2c-.051-.324.312-.389-.137-.015a6.232,6.232,0,0,1-.6.449,20.5,20.5,0,0,1-4.036,2.028c-3.506,1.327-8.293,2.341-10.753-1.278-1.439-2.117-4.906-.118-3.454,2.019Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M111.409,313.092a99.249,99.249,0,0,0,6.891-14.219c.992-2.4,1.943-4.824,2.911-7.237.918-2.284,2.1-4.662.171-6.821a29.3,29.3,0,0,0-4.533-3.547c-1.7-1.257-3.407-2.5-5.106-3.755a70.8,70.8,0,0,1-8.832-7.2c-.2-.2-.394-.41-.581-.624-.106-.121-.212-.243-.311-.369-.215-.271.232.362-.056-.083-.122-.188-.236-.376-.343-.573-.127-.236.1.457.041.076-.032-.208-.075-.412-.106-.623a65.038,65.038,0,0,1-.6-6.885c-.165-4.356-.087-8.714-.281-13.071-.162-3.663-.324-7.344-.712-10.992a39.3,39.3,0,0,0-4.419-14.045,42.932,42.932,0,0,0-11.568-13.384,70.989,70.989,0,0,0-7.644-5.748,34.1,34.1,0,0,0-8.481-3.531c-2.484-.69-3.545,3.168-1.064,3.858a29.834,29.834,0,0,1,6.974,2.8,50.227,50.227,0,0,1,6.653,4.851c3.959,3.228,7.652,6.5,10.367,10.883a36.422,36.422,0,0,1,3.4,7.043,39.15,39.15,0,0,1,1.127,3.8q.207.853.375,1.717c.07.359.126.721.193,1.08.113.61.01.006.024.119.406,3.266.534,6.58.7,9.864.206,4.14.235,8.27.3,12.413.035,2.234.132,4.467.357,6.691.18,1.773.15,3.84,1.089,5.414,1.555,2.609,4.367,4.6,6.711,6.432,3.246,2.541,6.6,4.94,9.909,7.394.805.6,1.609,1.193,2.4,1.806.844.651,1.3.7.888,1.747-.933,2.389-1.91,4.765-2.87,7.144a103.014,103.014,0,0,1-7.423,15.559c-1.351,2.2,2.108,4.211,3.454,2.019Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M91.607,141.277a30.634,30.634,0,0,1-3.825,5.741c-1.489,1.89-3,3.776-4.579,5.594a57.171,57.171,0,0,1-4.736,4.8,24.281,24.281,0,0,1-4.964,3.737c-2.284,1.188-.264,4.641,2.019,3.454a27.889,27.889,0,0,0,5.555-4.165,56.819,56.819,0,0,0,4.954-5c1.647-1.9,3.231-3.869,4.779-5.849a34.151,34.151,0,0,0,4.251-6.3,2.057,2.057,0,0,0-.717-2.737,2.018,2.018,0,0,0-2.737.718Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M377.473,205.287c-.126-3.024-.4-6.04-.775-9.044a2.185,2.185,0,0,0-.585-1.414,2.034,2.034,0,0,0-1.415-.586c-.973.044-2.137.888-2,2,.371,3,.649,6.02.775,9.044a2,2,0,0,0,4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M307.463,80.245c-2.6,1.507-5.17,3.054-7.686,4.693q-1.77,1.153-3.5,2.365a12.1,12.1,0,0,0-2.924,2.4c-1.5,2-.533,4.271.342,6.3,1.234,2.872,2.62,5.675,3.943,8.506l.718-2.736A40.719,40.719,0,0,0,293.2,104.6c-1.413.934-3.3,1.99-3.759,3.736a8.474,8.474,0,0,0,.365,3.707q.346,1.71.7,3.417,2.016,9.833,4.113,19.647,1.186,5.54,2.426,11.067c.568,2.51,4.425,1.448,3.857-1.063-2.608-11.536-5.008-23.122-7.354-34.714-.057-.279-.232-1.107-.242-1.085-.086.184.5-.266.567-.314q.459-.339.929-.662a39.823,39.823,0,0,1,5.576-3.107,2.04,2.04,0,0,0,.717-2.736c-1.09-2.333-2.223-4.646-3.278-7a24.9,24.9,0,0,1-1.128-2.764c-.2-.631-.32-.557.333-1.079a100.946,100.946,0,0,1,12.465-7.96c2.225-1.293.214-4.751-2.018-3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M364.372,179.367a13.729,13.729,0,0,1,2.209.606c.08.029.159.059.238.09s.418.172.116.043c-.283-.12,0,0,.053.026.1.043.193.088.289.134.345.164.684.343,1.014.535q.468.273.914.581c.156.108.3.237.465.336-.472-.291.019.019.144.123a13.846,13.846,0,0,1,1.666,1.663,2.01,2.01,0,0,0,2.829,0,2.053,2.053,0,0,0,0-2.828,15.622,15.622,0,0,0-8.874-5.166,2,2,0,1,0-1.063,3.857Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M307.743,100.326a15.191,15.191,0,0,0,4.6,4.144,14.908,14.908,0,0,0,6.914,1.627,90.413,90.413,0,0,0,11.794-.85,2.062,2.062,0,0,0,2-2,2.012,2.012,0,0,0-2-2c-3.554.419-7.159.76-10.739.844a9.97,9.97,0,0,1-9.742-4.594,2.012,2.012,0,0,0-2.828,0,2.05,2.05,0,0,0,0,2.829Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M272.807,127.178a85.071,85.071,0,0,1-12.133-15.015,2.035,2.035,0,0,0-3.142-.4l-15.591,13.255a19.447,19.447,0,0,0-3.544,3.207c-1.114,1.595-.577,3.186.161,4.807,1.315,2.892,2.762,5.727,4.293,8.51,2.666,4.844,5.554,9.925,9.73,13.645a17.71,17.71,0,0,0,14.693,4.635c5.917-.91,11.263-4.638,14.967-9.229a2.062,2.062,0,0,0,0-2.829,2.015,2.015,0,0,0-2.829,0c-3.977,4.931-10.492,9.4-17.151,8.109-6.806-1.314-10.935-7.685-14.19-13.242q-1.807-3.084-3.447-6.263-.819-1.588-1.6-3.2c-.452-.936-1.391-2.225-1.279-3.272l-.273,1.009c.337-.795,1.318-1.38,1.962-1.928l2.472-2.1,4.754-4.041,9.7-8.244-3.141-.405a89.825,89.825,0,0,0,12.758,15.824c1.835,1.809,4.665-1.017,2.829-2.828Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M347.1,318.87c.018-13.125.091-26.25.139-39.375q.015-4.132.028-8.263c.006-2.574-3.994-2.578-4,0q-.05,19.8-.145,39.6-.013,4.017-.022,8.035c0,2.574,4,2.578,4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M330.192,275.917q0,17.534.013,35.067,0,3.743,0,7.484c0,2.574,4,2.578,4,0q.022-17.468-.007-34.936,0-3.807,0-7.615c0-2.574-4-2.579-4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M344.568,321.143a115.88,115.88,0,0,1,24.871,10.165c3.543,1.966,6.981,4.118,10.31,6.428,3.275,2.273,7.008,4.634,9.637,7.662a4.356,4.356,0,0,1,1.193,2.5,1.8,1.8,0,0,1-.086.354c.007-.053.343-.411.126-.167a5.405,5.405,0,0,1-.732.653,8.958,8.958,0,0,1-4.675,2.113l1.01.273c-6.589-4.188-13.2-8.367-20.169-11.907a122.7,122.7,0,0,0-22.7-8.781c-2.484-.691-3.544,3.167-1.064,3.857a117.618,117.618,0,0,1,22.423,8.724c3.345,1.725,6.613,3.594,9.835,5.536q2.556,1.542,5.083,3.132,1.221.767,2.438,1.537a8.8,8.8,0,0,0,2.88,1.593c1.724.274,3.777-.7,5.238-1.513a13.484,13.484,0,0,0,3.263-2.389c3-3.2-.246-7.611-2.749-9.844a106.7,106.7,0,0,0-18.722-12.927,120.572,120.572,0,0,0-26.345-10.858c-2.481-.7-3.541,3.159-1.063,3.858Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M332.409,316.475a57.056,57.056,0,0,0-11.749,1.877,118.986,118.986,0,0,0-12.915,3.941c-2.395.881-1.36,4.749,1.064,3.857a119.406,119.406,0,0,1,12.533-3.847,52.825,52.825,0,0,1,11.067-1.828c2.568-.075,2.579-4.075,0-4Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M327.14,327.226a61.585,61.585,0,0,0-18.395,4.991,2.012,2.012,0,0,0-.717,2.736,2.051,2.051,0,0,0,2.736.717c.075-.032.283-.118.091-.039l.5-.2c.281-.113.563-.222.846-.33.687-.262,1.38-.51,2.076-.749q2.216-.759,4.475-1.389a49.512,49.512,0,0,1,8.388-1.734,2.054,2.054,0,0,0,2-2,2.015,2.015,0,0,0-2-2Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M325.726,327.812a91.219,91.219,0,0,0-6.145,7.278,110.739,110.739,0,0,0-8.856,12.594c-1.338,2.272-1.019,4.829,1.522,6.029,2.086.985,4.342,2.358,6.727,2.084,2.68-.308,4.334-2.986,6.043-4.82,1.927-2.067,3.866-4.124,5.836-6.15a146,146,0,0,1,12.4-11.562,2.012,2.012,0,0,0,0-2.828,2.046,2.046,0,0,0-2.828,0c-7.079,5.761-13.351,12.443-19.547,19.123-.584.629-1.336,1.838-2.094,2.226-.642.329-1.524-.179-2.083-.438a28.12,28.12,0,0,1-2.878-1.283c.128.078-.136.252.137.015a7.906,7.906,0,0,0,1.018-1.7,110.237,110.237,0,0,1,7.685-10.778,87.162,87.162,0,0,1,5.893-6.961c1.8-1.84-1.023-4.67-2.829-2.828Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M308.333,83.491a111.14,111.14,0,0,0-1.592,13.434c-.148,3.454-.139,6.916-.1,10.372.077,7.4.325,14.8.693,22.185.1,2,.121,4.047.388,6.037a2.068,2.068,0,0,0,2,2c.969,0,2.145-.922,2-2-.22-1.644-.247-3.329-.334-4.983q-.258-4.926-.424-9.855c-.261-7.38-.483-14.784-.275-22.168a103.06,103.06,0,0,1,1.5-13.958,2.06,2.06,0,0,0-1.4-2.461,2.017,2.017,0,0,0-2.46,1.4Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M342.076,80.338a391.666,391.666,0,0,1-24.912,41.639q-4.161,6.166-8.49,12.217a2.016,2.016,0,0,0,.718,2.736,2.043,2.043,0,0,0,2.736-.717,471.077,471.077,0,0,0,27.262-42.4q3.189-5.661,6.14-11.453c1.162-2.29-2.288-4.317-3.454-2.019Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M266.5,121.726c2.312-7.335,5.742-14.729,10.688-20.679a26.282,26.282,0,0,1,7.8-6.416,61.967,61.967,0,0,1,10.5-4.33c1.982-.647,3.984-1.212,5.921-1.991,2.124-.855,4.206-1.8,6.35-2.609a2.055,2.055,0,0,0,1.4-2.46,2.015,2.015,0,0,0-2.46-1.4c-3.855,1.449-7.566,3.1-11.5,4.349a73.74,73.74,0,0,0-11.353,4.519,29.555,29.555,0,0,0-8.635,6.513,52.65,52.65,0,0,0-6.842,9.926,75.974,75.974,0,0,0-5.729,13.512c-.776,2.46,3.085,3.513,3.857,1.063Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M341.3,202.182c.125.043.252.085.382.127a12.845,12.845,0,0,0,5.712-.068c4.662-1.816,7.553-4.226,9.417-8.975.922-1.844,1.5-3.824,2.423-5.667,1.241-2.481,2.108-8.19-.706-11.31.193-2.519.113-4.6.113-6.183,0-2.425-.638-3.622-1.5-4.411a6.282,6.282,0,0,0-4.768-1.02l-1.031.238c-.663,1.372-1.3,2.723-1.888,4.045l-.807,1.55c-1.88-1.2-4.638-2.768-5.8-2.975-3.828-.632-4.525,4.56-2.859,6.662-2.1-1.617-3.206-1.712-4.649-1.056-2.244,1.02-1.9,3.411-1,5.169-.679-.6-2.339-.307-3.1.695a4.435,4.435,0,0,0,1.034,6.185c-1.512-.441-2.929.923-3.472,2.4-1.284,3.5,2.454,7.919,5.6,10.587A19.1,19.1,0,0,0,341.3,202.182Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M342.756,82.844a56.609,56.609,0,0,1,6.886,6.2c1.841,2.086,4.011,4.207,4.728,6.98l.919-2.259a102.194,102.194,0,0,0-11.2,8.392,2.026,2.026,0,0,0-.313,2.424c.919,1.682,1.984,3.281,2.885,4.973.091.17.178.342.265.514.133.262.013.092.053.1a1.769,1.769,0,0,1,.063.186l.095-1.056c.024.014-.48.8-.5.823-.625.95-1.38,1.81-2,2.766-1.4,2.17,2.063,4.177,3.454,2.018.735-1.14,1.674-2.141,2.346-3.324a3.153,3.153,0,0,0,.062-3.26c-.92-2.006-2.221-3.822-3.277-5.755l-.313,2.423a94.543,94.543,0,0,1,10.388-7.766,2.058,2.058,0,0,0,.919-2.258c-.824-3.19-3.06-5.709-5.2-8.113a62.685,62.685,0,0,0-7.445-6.833,2.06,2.06,0,0,0-2.829,0,2.016,2.016,0,0,0,0,2.829Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M360.542,176.166c.121-1.72.125-3.44.109-5.164a11.5,11.5,0,0,0-.831-5.02c-1.386-2.886-5.03-3.858-7.979-3.236a2.016,2.016,0,0,0-1.4,2.461,2.049,2.049,0,0,0,2.46,1.4c.407-.086.047.06-.069,0,.07.038.3-.024.394-.027.291-.01.579.01.869.024.507.026-.428-.087.079.006.154.028.307.056.459.092a6.211,6.211,0,0,1,.882.275c-.3-.12-.141-.059.052.052l.123.072c.181.123.159.1-.068-.072a5.081,5.081,0,0,1,.433.424c.292.3-.122-.227-.044-.06.048.1.128.194.185.291s.1.223.167.324c.075.117-.132-.419-.009.009.076.261.153.518.2.786.031.165.056.481.026.136.016.187.034.373.043.56.033.663.019,1.33.025,1.994.014,1.561,0,3.121-.114,4.68a2.01,2.01,0,0,0,2,2,2.049,2.049,0,0,0,2-2Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M348.51,171.06c3.991-8.923,10.851-21.29,14.842-30.213a11.97,11.97,0,0,0,1.466-5.544,8.113,8.113,0,0,0-2.6-5.224c-2.713-2.647-18.783-17.186-26.881-24.527a3.181,3.181,0,0,0-2.847-.806,3.371,3.371,0,0,0-2.443,2.448c-7.393,21.105-16.318,42.653-21.024,55.578-.988,2.712-1.933,5.6-2.565,7.773a6.3,6.3,0,0,0,.618,5.539c1.522,2.212,16.545,18.951,22.981,25.227"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M351.181,169.968c3.538-7.876,7.778-15.411,11.57-23.163.9-1.838,1.783-3.686,2.6-5.563a12.463,12.463,0,0,0,1.393-6.6c-.382-2.97-2.192-5.13-4.294-7.1-3.87-3.621-7.807-7.173-11.729-10.738-4.618-4.2-9.169-8.489-13.877-12.584a5.3,5.3,0,0,0-5.539-1.178c-2.041.8-2.822,2.585-3.5,4.523q-2.311,6.566-4.756,13.082c-3.1,8.316-6.332,16.585-9.555,24.856-2.662,6.832-5.436,13.649-7.741,20.612-1.182,3.573-2.725,7.609-.343,11.056a44.367,44.367,0,0,0,3.029,3.678c3.72,4.3,7.544,8.513,11.4,12.686,1.982,2.142,3.977,4.273,6.008,6.369,1.861,1.921,4.194,5.129,7.235,4.29a5.633,5.633,0,0,0,3.195-2.937c1.244-2.256-2.209-4.276-3.454-2.019-.207.375-.513.694-.719,1.036-.189.315-.376-.095.061.082a2.489,2.489,0,0,1-.766-.532c-.759-.693-1.465-1.456-2.183-2.192-1.814-1.859-3.6-3.75-5.366-5.651q-5.639-6.055-11.11-12.266c-1.181-1.345-2.365-2.691-3.5-4.079-.147-.18-.595-.8-.217-.259a6.314,6.314,0,0,1-.573-.888c-.732-1.524-.149-3.177.314-4.685,1.969-6.42,4.476-12.676,6.905-18.934,2.856-7.359,5.744-14.707,8.557-22.084q2.286-5.994,4.5-12.017,1.116-3.047,2.206-6.1c.346-.971.63-2,1.039-2.941.207-.478.466-.984,1.047-1.051.98-.114,2.125,1.4,2.78,1.994l3.008,2.726q3.342,3.03,6.683,6.061,6.072,5.511,12.118,11.052c1.119,1.031,2.271,2.042,3.336,3.13a5.827,5.827,0,0,1,1.868,4.549,17.411,17.411,0,0,1-1.96,5.339c-3.345,7.2-7.209,14.151-10.705,21.28q-1.252,2.552-2.423,5.143a2.061,2.061,0,0,0,.717,2.736,2.016,2.016,0,0,0,2.737-.717Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M351.03,169.706a38.454,38.454,0,0,0-4.979-3.012c-1.694-.86-3.485-1.6-5.393-.959-3.659,1.221-4.535,6.57-2.4,9.469L341,172.468c-2.343-1.75-5.231-2.427-7.67-.4-2.253,1.873-1.865,4.877-.719,7.248l2.736-2.737c-2.475-1.736-5.624.35-6.552,2.771a6.535,6.535,0,0,0,2.061,7.25l1.946-3.342c-2.847-.58-5.258,1.411-6.031,4.1-.691,2.408.245,4.979,1.54,7.005a24.43,24.43,0,0,0,11.326,9.327,13.512,13.512,0,0,0,6.152.858,14.092,14.092,0,0,0,6.083-2.252c4.325-2.631,6.29-6.787,8.088-11.335.975-2.464,2.066-4.63,2.358-7.3a11.686,11.686,0,0,0-1.7-7.962c-1.469-2.09-4.939-.093-3.454,2.019,1.818,2.586,1.5,6.362.253,9.07-1.621,3.51-2.591,7.662-5.445,10.435a11.136,11.136,0,0,1-8.036,3.364c-3.264-.1-6.39-2.228-8.808-4.422a16.492,16.492,0,0,1-4.1-5.114,4.311,4.311,0,0,1-.481-2.32c.078-.523.639-1.725,1.185-1.614,1.765.359,3.624-1.968,1.946-3.343a2.85,2.85,0,0,1-1.274-2.627,1.821,1.821,0,0,1,.448-.965,1.206,1.206,0,0,1,.491-.2c.074-.024-.475-.263-.022.054,1.783,1.251,3.524-1.107,2.737-2.736-.328-.677-.75-1.756-.031-2.27,1.006-.721,2.089.252,2.947.893,1.577,1.177,3.9-1.16,2.737-2.737a3.047,3.047,0,0,1-.52-2.467,2.266,2.266,0,0,1,.4-.959c.222-.249.338-.309.826-.27a4.711,4.711,0,0,1,1.089.4c.653.311,1.29.657,1.919,1.013a39.96,39.96,0,0,1,3.584,2.258,2.018,2.018,0,0,0,2.737-.718,2.043,2.043,0,0,0-.718-2.736Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M349.184,178.589c-1.181-.875-2.4-1.69-3.608-2.528q-.372-.26-.74-.526-.206-.15-.411-.3l-.189-.144c-.175-.133.424.335.134.1q-.924-.738-1.8-1.528a2,2,0,1,0-2.829,2.828c2.309,2.087,4.933,3.708,7.425,5.553a2.01,2.01,0,0,0,1.541.2,2.038,2.038,0,0,0,1.2-.919,2.017,2.017,0,0,0,.2-1.541,2.317,2.317,0,0,0-.919-1.195Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M345.087,184.861c-.148-.1-.29-.207-.432-.314-.267-.2.464.364.081.062q-.189-.149-.376-.3c-.589-.474-1.17-.959-1.746-1.449-1.317-1.118-2.618-2.258-3.871-3.448-.536-.508-1.071-1.023-1.554-1.582a2.009,2.009,0,0,0-2.828,0,2.049,2.049,0,0,0,0,2.828,34.961,34.961,0,0,0,3.222,3.114c1.253,1.119,2.527,2.215,3.832,3.272.539.436,1.076.886,1.653,1.271a2.014,2.014,0,0,0,2.737-.717,2.049,2.049,0,0,0-.718-2.737Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M341.739,190.93c-.4-.271-.8-.547-1.191-.832q-.273-.2-.543-.4c-.245-.186-.053-.047.076.06-.089-.074-.183-.144-.274-.216q-.936-.747-1.806-1.572c-1.163-1.1-2.227-2.305-3.286-3.507a2.014,2.014,0,0,0-2.829,0,2.049,2.049,0,0,0,0,2.829c1.082,1.228,2.171,2.455,3.363,3.578a35.224,35.224,0,0,0,4.471,3.517,2.013,2.013,0,0,0,2.736-.717,2.049,2.049,0,0,0-.717-2.737Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M350.784,90.188a53.729,53.729,0,0,1,12.076,8.645,39.352,39.352,0,0,1,8.447,12.3c3.312,7.426,4.6,15.551,5.837,23.529q.829,5.355,1.611,10.719.375,2.565.739,5.131.157,1.113.312,2.227c.111.806.125.908.21,1.549.637,4.846,1.084,9.722,1.4,14.6.358,5.553,1.17,11.469-.712,16.816-1.905,5.411-7.106,8.4-12.179,10.469a77.127,77.127,0,0,1-7.417,2.5c-2.782.817-5.842,1.831-8.78,1.394a2.065,2.065,0,0,0-2.46,1.4,2.014,2.014,0,0,0,1.4,2.46c5.39.8,11.03-1.247,16.057-3.037,4.908-1.748,9.977-4.087,13.626-7.914a17.647,17.647,0,0,0,3.982-7.339,27.474,27.474,0,0,0,.854-9.022q-.284-9.183-1.29-18.323c-.775-7.115-1.894-14.2-2.966-21.274-1.213-8-2.329-16.1-5.087-23.75a45.586,45.586,0,0,0-9.209-15.686A55.377,55.377,0,0,0,352.8,86.734c-2.265-1.224-4.287,2.228-2.019,3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M242.791,221.123c-7.126,4.065-12.854,10.888-14,19.163-1.4,10.084-1.069,20.2-.67,30.344.79,20.06,1.682,40.257,4.953,60.1.394,2.387,1.16,4.65,3.208,6.109a16.9,16.9,0,0,0,6.8,2.335,29.929,29.929,0,0,0,15.415-1.329c2.4-.878,1.362-4.745-1.063-3.857a26.226,26.226,0,0,1-12.509,1.453,19.832,19.832,0,0,1-5.617-1.463c-1.782-.832-2.079-2.524-2.374-4.312-1.509-9.153-2.415-18.421-3.126-27.666-.721-9.381-1.173-18.779-1.556-28.178-.385-9.452-.868-18.909-.047-28.353.37-4.247.9-8.1,3.084-11.829a25.783,25.783,0,0,1,9.525-9.059c2.236-1.275.223-4.733-2.019-3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M263.521,246.681c-2.455,5.949-2.16,12.54-2.127,18.849q.04,7.554.067,15.107.067,17.065.126,34.131.032,8.268.076,16.534c.015,2.573,4.015,2.579,4,0-.123-21.235-.153-42.47-.258-63.705-.033-6.624-.609-13.6,1.973-19.852a2.013,2.013,0,0,0-1.4-2.461,2.052,2.052,0,0,0-2.46,1.4Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M261.47,259.218c.194,11.889.658,23.774,1.111,35.656.474,12.439,1,24.876,1.458,37.315.089,2.418.168,4.837.254,7.256.121,3.4.351,7.149,2.429,9.994,4.659,6.378,14.478,4.5,21,2.81a34.777,34.777,0,0,0,5.828-1.984,11.756,11.756,0,0,0,4.037-2.588c1.252-1.474,1.188-3.466,1.356-5.289q.264-2.868.481-5.739c.613-8.041.992-16.1,1.251-24.16.265-8.238.4-16.48.475-24.722q.027-2.964.044-5.926a44.935,44.935,0,0,1,.047-5.615c.446-3.308,3.944-5.013,6.579-6.362,1.407-.72,2.846-1.368,4.3-1.98a2.067,2.067,0,0,0,1.4-2.46,2.012,2.012,0,0,0-2.46-1.4c-5.892,2.477-13.768,5.565-13.843,13.091-.077,7.754-.091,15.506-.237,23.259-.151,8.051-.389,16.1-.8,24.143q-.3,5.853-.727,11.7-.209,2.772-.457,5.541c-.113,1.256.188,2.971-.983,3.7a30.615,30.615,0,0,1-10.743,3.68c-3.324.619-7.171,1.217-10.447.068-3.11-1.09-4.112-4.12-4.382-7.138-.226-2.537-.228-5.1-.32-7.648-.429-11.947-.934-23.892-1.4-35.838-.464-11.971-.93-23.945-1.188-35.922q-.037-1.724-.066-3.447c-.042-2.571-4.042-2.579-4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M235.547,334.847c-4.3,7.4-12.465,10.282-18.665,15.669-4.76,4.136-10.149,11.728-6.869,18.249,1.68,3.341,5.412,5.426,8.986,6.054a21.312,21.312,0,0,0,12.919-2.157c3.972-1.914,7.711-4.322,11.484-6.592,2.967-1.784,6.019-3.414,8.876-5.376,2.937-2.017,5.906-4.352,7.741-7.469a10.126,10.126,0,0,0-.032-10.519c-1.289-2.227-4.747-.215-3.454,2.019a6.119,6.119,0,0,1-.12,6.731,20.056,20.056,0,0,1-5.642,5.428c-2.42,1.707-4.992,3.122-7.538,4.627-3.428,2.027-6.8,4.154-10.28,6.086-3.359,1.863-6.842,3.492-10.763,3.51-3.048.014-6.66-1.022-8.38-3.754-1.457-2.315-.56-5.3.6-7.571a22.43,22.43,0,0,1,5.736-6.809c3.172-2.668,6.893-4.517,10.221-6.964A30.709,30.709,0,0,0,239,336.866c1.3-2.23-2.16-4.246-3.454-2.019Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M267.459,349.462c-2.479,7.866-10.117,12.424-15.808,17.8-5.921,5.591-12.116,15.158-5.2,22.492,3.493,3.7,9.165,4.329,14,4.15a27.044,27.044,0,0,0,14.588-4.673,47.3,47.3,0,0,0,5.142-4.637c1.394-1.326,2.881-2.552,4.388-3.747,2.987-2.367,6.109-4.6,8.86-7.244,2.848-2.74,5.291-6.055,5.777-10.076.585-4.85-1.982-9.255-4.877-12.919a2.013,2.013,0,0,0-2.829,0,2.052,2.052,0,0,0,0,2.829c2.159,2.732,4.1,6.093,3.759,9.621-.245,2.527-1.988,5-3.9,6.966a75.51,75.51,0,0,1-8,6.728,94.459,94.459,0,0,0-8.112,7.147,21.887,21.887,0,0,1-12.133,5.776,27.042,27.042,0,0,1-6.822.082,11.926,11.926,0,0,1-6.024-1.921c-6.961-5.268.076-13.907,4.543-18.058,6.25-5.809,13.806-10.693,16.5-19.25.776-2.461-3.084-3.514-3.857-1.064Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M267.177,248.222c3.38-5.891,8.763-10.27,13.782-14.723q3.048-2.7,6.194-5.3a51.253,51.253,0,0,1,5.37-4.14c2.177-1.363.171-4.825-2.019-3.454a57.687,57.687,0,0,0-5.943,4.571q-3.261,2.693-6.431,5.5c-5.286,4.69-10.846,9.326-14.407,15.532-1.284,2.237,2.171,4.254,3.454,2.019Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M243.93,220.643l-.008.027,1.009.273-.189-.127.718.718-.1-.228.273,1.009.027-.327L245.383,223a9.645,9.645,0,0,1,2.465-1.981q1.62-1.222,3.267-2.408c2.032-1.464,4.09-2.889,6.164-4.293,4.133-2.8,8.328-5.506,12.5-8.242a58.692,58.692,0,0,0,8.394-6.092,24.505,24.505,0,0,0,6.6-9.947c2.189-6.508,2.465-13.5,2.28-20.31a99.69,99.69,0,0,0-.982-11.742,49.354,49.354,0,0,0-2.94-10.754,26.82,26.82,0,0,1-1.895-8.621,46.565,46.565,0,0,1,.554-8.617c.9-6.156,2.08-12.28,3.2-18.4.459-2.516-3.395-3.6-3.858-1.063-1.032,5.656-2.08,11.315-2.982,16.994-.854,5.375-1.425,10.861-.277,16.239a55.8,55.8,0,0,0,2.49,7.285,34.409,34.409,0,0,1,1.34,5,77.579,77.579,0,0,1,1.285,11.786c.306,6.977.231,14.174-1.98,20.87-2.535,7.681-9.472,11.455-15.8,15.586-4.917,3.21-9.839,6.418-14.633,9.81q-3.519,2.49-6.922,5.134c-1.13.881-2.4,2-1.952,3.614a2.476,2.476,0,0,0,3.292,1.653,2.059,2.059,0,0,0,1.4-2.46,2.016,2.016,0,0,0-2.46-1.4Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M111.63,308.959a60.8,60.8,0,0,0,9.394,4.084,15.22,15.22,0,0,1,6.368,3.767c1.663,1.719,2.735,3.973,4.507,5.563a9.688,9.688,0,0,0,7.2,2.665,7.7,7.7,0,0,0,6.45-3.931c1.415-2.854,1.048-6.13.556-9.16a61.775,61.775,0,0,0-2.426-9.783c-.982-2.919-2.025-6.138-4.131-8.462-2.183-2.41-5.43-3.339-8.514-3.938-3.342-.649-6.695-1.25-10.042-1.87-2.516-.467-3.595,3.388-1.063,3.857q3.954.732,7.908,1.472c2.4.446,5.024.742,7.181,1.957,2.212,1.247,3.154,3.569,4.014,5.838a61.976,61.976,0,0,1,2.5,8.307c.819,3.628,2.952,11.538-2.931,11.744a6.018,6.018,0,0,1-4.709-2.388c.261.322-.379-.591-.49-.753-.429-.623-.882-1.227-1.348-1.822a25.075,25.075,0,0,0-2.477-2.764,18.6,18.6,0,0,0-6.831-3.922,61.171,61.171,0,0,1-9.1-3.914c-2.253-1.251-4.273,2.2-2.019,3.453Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M341.666,125.464c1.613,1.374,3.24,2.732,4.924,4.018a2.006,2.006,0,0,0,1.541.2,2.046,2.046,0,0,0,1.2-.919,2.02,2.02,0,0,0,.2-1.542l-.2-.477a2.008,2.008,0,0,0-.718-.718l-.2-.152.4.313c-1.475-1.141-2.9-2.345-4.322-3.553a2.13,2.13,0,0,0-1.414-.586,2.036,2.036,0,0,0-1.414.586,2.01,2.01,0,0,0-.586,1.414,1.977,1.977,0,0,0,.586,1.414Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M244.931,224a410.938,410.938,0,0,1,39.8-12.9q4.714-1.212,9.476-2.237c2.515-.542,1.45-4.4-1.064-3.857a310.829,310.829,0,0,0-36.22,10.45q-6.551,2.271-13.052,4.686c-2.394.884-1.359,4.751,1.063,3.857Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M291.672,206.939c-.51,6.686-.751,13.528.393,20.166.82,4.758,2.721,9.344,4.6,13.766a76.3,76.3,0,0,0,6.187,12.06c2.34,3.58,4.309,7.4,6.6,11.014a72.932,72.932,0,0,0,4.44,6.332c1.278,1.611,3.361,4.653,5.662,4.138,4.886-1.093,8.691-3.874,12.472-6.964a24.1,24.1,0,0,1,6.712-3.418c3.045-1.068,6.083-2.055,9.071-3.282,5.225-2.148,10.7-4.309,15.516-7.307a23.318,23.318,0,0,0,8.515-9.752,28.728,28.728,0,0,0,1.708-18.628c-.552-2.514-4.409-1.45-3.857,1.063a24.385,24.385,0,0,1-1.177,15.271,20.515,20.515,0,0,1-6.713,8.271,45.643,45.643,0,0,1-5.757,3.085q-4.18,2.019-8.475,3.8c-2.862,1.191-5.746,2.236-8.687,3.213a31.637,31.637,0,0,0-8.2,3.72c-1.573,1.1-2.941,2.455-4.5,3.566a23.715,23.715,0,0,1-7.909,3.564l1.946.514c-3.33-2.736-5.706-6.6-7.949-10.226-2.055-3.318-3.859-6.8-6-10.064a72.219,72.219,0,0,1-5.791-11.172,68.426,68.426,0,0,1-4.257-12.158c-1.473-6.667-1.051-13.818-.536-20.571.2-2.568-3.805-2.555-4,0Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M374.345,224.939q2.853,16.791,6.844,33.362a3.591,3.591,0,0,1-1.853,4.041,60.878,60.878,0,0,1-9.78,4.021,3.578,3.578,0,0,1-4.51-2.584c-2.529-10.321-5.874-24.427-7.605-34.615l-.779-3.915,17.07-3.819Z"
            ></path>
            <path
              class="a"
              fill="#ffffff"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M388.965,220.263c3.887-2.4,5.88-5.554,4.9-11.515-.4-2.4-3.658-6.739-10.617-5.227a361.724,361.724,0,0,0-42.957,11.025c-6.627,2.119-9.038,7.105-8.384,10.971,1.038,6.142,7.159,6.832,10.916,6.1C350.129,230.185,385.8,222.213,388.965,220.263Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M355.513,229.7c1,5.857,2.245,11.671,3.55,17.467q1.028,4.567,2.115,9.121c.656,2.758,1.138,5.662,2.036,8.351a5.657,5.657,0,0,0,6.546,3.741,42.778,42.778,0,0,0,9.153-3.593,8.421,8.421,0,0,0,3.128-2.145,5.608,5.608,0,0,0,1.143-4.522c-.566-3.375-1.57-6.724-2.306-10.068q-2.586-11.763-4.6-23.64a2.015,2.015,0,0,0-2.46-1.4,2.046,2.046,0,0,0-1.4,2.46q1.594,9.354,3.533,18.645,1,4.762,2.086,9.506.49,2.134,1,4.264c.254,1.065.476,1.958-.554,2.64a34.768,34.768,0,0,1-7.677,3.328c-.885.307-2.071.971-3,.5-.865-.444-.934-1.519-1.14-2.365-1.29-5.285-2.551-10.577-3.746-15.884-1.305-5.8-2.549-11.61-3.55-17.467a2.015,2.015,0,0,0-2.46-1.4,2.046,2.046,0,0,0-1.4,2.46Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M389.974,221.99a12.646,12.646,0,0,0,5.47-6.274,13.114,13.114,0,0,0,.082-8.435,9.183,9.183,0,0,0-4.639-4.993c-3.186-1.5-6.39-1.066-9.722-.374a398.021,398.021,0,0,0-40.932,10.553c-5.481,1.758-11.008,6.194-10.39,12.581.574,5.936,5.723,9.158,11.385,8.774a68.553,68.553,0,0,0,9.761-1.894q7.038-1.542,14.053-3.177c4.8-1.117,9.587-2.26,14.355-3.488a80.415,80.415,0,0,0,9.256-2.683,8.825,8.825,0,0,0,1.321-.59c2.208-1.318.2-4.778-2.019-3.454-.107.064-.223.11-.33.173-.357.208.507-.177-.081.031-.5.177-.992.356-1.5.517-1.421.456-2.86.856-4.3,1.248-4,1.088-8.032,2.074-12.064,3.041-8.113,1.945-16.25,3.8-24.413,5.527-3.011.636-6.092,1.51-8.969-.164-3.983-2.318-2.689-7.58.3-10.164,2.434-2.107,5.8-2.784,8.8-3.71q5.088-1.572,10.218-3c5.783-1.605,11.613-3.027,17.474-4.318,3.425-.755,6.859-1.475,10.3-2.183,2.489-.512,5.258-.489,7.158,1.318a4.175,4.175,0,0,1,.8.952,2.559,2.559,0,0,1,.44.869,10.478,10.478,0,0,1,.265,4.138c-.322,2.595-1.954,4.384-4.1,5.729C385.78,219.9,387.785,223.364,389.974,221.99Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M312.037,71.048a10.654,10.654,0,0,0,5.114,1.055,10.465,10.465,0,0,0,2.563-.369,19.086,19.086,0,0,0,2.72-1.22,2.008,2.008,0,0,0,.718-2.736,2.056,2.056,0,0,0-2.737-.717c-.36.168-.711.355-1.067.533-.086.043-.171.086-.258.128-.025.012-.443.206-.137.066.256-.118.022-.014-.038.005l-.211.068c-.3.09-.6.142-.909.2-.257.052.432-.044.168-.021-.082.007-.164.018-.247.025-.188.017-.377.028-.565.034q-.512.015-1.022-.019c-.17-.011-.338-.028-.507-.046-.28-.028.074,0,.157.022a2.254,2.254,0,0,0-.246-.041,8.232,8.232,0,0,1-.992-.239c-.144-.044-.284-.106-.428-.148-.225-.065.373.193.178.076-.073-.043-.159-.075-.235-.114a2,2,0,0,0-2.019,3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M322.272,52.341c-.428-1.562-.006-5.113,2.935-5.324,3.875.144,3.947,4.455,2.579,6.438C326.667,55.079,323.5,55.67,322.272,52.341Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M299.985,51.608c-.405-1.563-.007-5.113,2.771-5.325,3.658.145,3.726,4.456,2.435,6.439C304.133,54.345,301.148,54.937,299.985,51.608Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M311.27,55.472c-.481.816-.942,1.647-1.35,2.5a4.09,4.09,0,0,0-.49,1.644,2.479,2.479,0,0,0,.826,1.938,3.593,3.593,0,0,0,1.489.847,8.181,8.181,0,0,0,1.07.141l-.532-.071.037,0a1.523,1.523,0,0,0,.8.036,1.49,1.49,0,0,0,.744-.238,2,2,0,0,0,.717-2.736,1.92,1.92,0,0,0-1.195-.919c-.309-.045-.618-.073-.928-.112l.532.071a1.621,1.621,0,0,1-.369-.1l.478.2a1.7,1.7,0,0,1-.308-.18l.4.313a1.918,1.918,0,0,1-.256-.237l.312.4a.453.453,0,0,1-.053-.09l.2.478a.769.769,0,0,1-.039-.15l.072.531a.986.986,0,0,1,0-.163l-.072.532a1.7,1.7,0,0,1,.115-.4l-.2.478a25.485,25.485,0,0,1,1.45-2.713,2.072,2.072,0,0,0,.2-1.541,2,2,0,0,0-2.461-1.4,2.1,2.1,0,0,0-1.195.919Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M340.18,77.719a40.975,40.975,0,0,0,6.312-6.852,33.231,33.231,0,0,0,3.263-5.2,2,2,0,0,0-3.453-2.019,33.007,33.007,0,0,1-3.15,5.048q-.141.193-.285.385c-.006.008-.375.493-.155.207-.2.256-.4.508-.6.758q-.687.84-1.42,1.64a38.275,38.275,0,0,1-3.338,3.206,2.011,2.011,0,0,0,0,2.829,2.053,2.053,0,0,0,2.829,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M346.926,6.313A35.367,35.367,0,0,0,329.213.078,42.378,42.378,0,0,0,311.9,2.669a35.058,35.058,0,0,0-13.509,8.941,34.208,34.208,0,0,0-8.058,16.315,51.5,51.5,0,0,0,.458,20.769c.545,2.515,4.4,1.451,3.857-1.063C292.367,37.1,293,24.452,300.077,15.755c6.512-8.005,16.759-11.724,26.888-11.744a31.512,31.512,0,0,1,17.942,5.756c2.137,1.447,4.141-2.017,2.019-3.454Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M331.667,77.868c-7.109,3.281-15.544,4.919-22.89,1.381a20.728,20.728,0,0,1-8.659-7.294,28.226,28.226,0,0,1-3.69-10.455c-.891-5.206-1.153-10.529-1.855-15.764a2.066,2.066,0,0,0-2-2c-.969,0-2.144.922-2,2,.7,5.2,1.057,10.451,1.811,15.645a32.7,32.7,0,0,0,4,12.133c4.524,7.55,13.461,11.906,22.139,11.72a38.1,38.1,0,0,0,15.166-3.912,2.015,2.015,0,0,0,.717-2.736,2.046,2.046,0,0,0-2.736-.718Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M350.183,13.756c7.108,6.4,8.914,15.547,9.3,24.712.109,2.564,4.109,2.578,4,0a51.854,51.854,0,0,0-2.513-15.39,29.4,29.4,0,0,0-7.961-12.151c-1.909-1.718-4.747,1.1-2.829,2.829Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M352.078,49.139a3.019,3.019,0,0,1,2.888-.31,1.94,1.94,0,0,1,.524.268q.3.208.054.025c.088.075.173.153.254.236s.345.476.085.072c.1.148.191.292.272.448a4,4,0,0,1,.288.968,8.508,8.508,0,0,1,.094,1.65,11.184,11.184,0,0,1-4.037,8.25,6.76,6.76,0,0,1-1.132.706c-.2.09-.2.093-.011.007-.124.048-.25.094-.377.136q-.42.141-.852.244a4.744,4.744,0,0,1-2.814-.021,2.061,2.061,0,0,0-2.736.718,2.016,2.016,0,0,0,.717,2.736,9.544,9.544,0,0,0,7.859-.262,12.3,12.3,0,0,0,5.234-5.138,15.7,15.7,0,0,0,2.124-6.865,8.416,8.416,0,0,0-1.829-6.417,7.008,7.008,0,0,0-8.624-.905,2.048,2.048,0,0,0-.718,2.736,2.02,2.02,0,0,0,2.737.718Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M296.946,38.733a38.37,38.37,0,0,0,10.335-2.6l-2.258-.919A10.66,10.66,0,0,0,320.929,36.7H318.1a11.182,11.182,0,0,0,13.77,1.687l-2.423-.312c2.1,2.625,4.078,5.663,6.638,7.871,2.122,1.83,6.836,4.114,8.935,1.122a1.943,1.943,0,0,0,0-2.019,2.3,2.3,0,0,0-1.984-1.123,2.05,2.05,0,0,0-1.928,1.468l-.041.113c-.877,2.425,2.987,3.47,3.857,1.064l.041-.113-1.929,1.468.167.005-1.727-.991.09.128V45.05l-.151.216,1.195-.919c-2.09.717-4.253-1.631-5.445-3.025-1.687-1.974-3.266-4.049-4.89-6.075a2.006,2.006,0,0,0-2.424-.313,7.141,7.141,0,0,1-8.923-1.062,2.037,2.037,0,0,0-2.828,0,6.585,6.585,0,0,1-9.624-.678,2.054,2.054,0,0,0-2.259-.919,34.771,34.771,0,0,1-9.272,2.458,2.061,2.061,0,0,0-2,2,2.012,2.012,0,0,0,2,2Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M52.877,410.254q0-14.831.028-29.659c0-2.574-4-2.578-4,0q-.014,14.829-.028,29.659c0,2.573,4,2.578,4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M64.526,409.688q0-14.921.029-29.84c0-2.574-4-2.578-4,0q-.015,14.919-.029,29.84c0,2.574,4,2.578,4,0Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M49.789,408.658A122.06,122.06,0,0,0,7.624,430.222C4.773,432.447.9,435.54,1.673,439.646c.541,2.871,4.062,4.656,6.556,5.533a7.457,7.457,0,0,0,2.431.475c1.121-.007,2.04-.822,2.951-1.4q2.586-1.635,5.188-3.245c3.184-1.961,6.4-3.869,9.691-5.65a117.462,117.462,0,0,1,24.6-9.9c2.477-.687,1.425-4.547-1.063-3.857a120.757,120.757,0,0,0-22.356,8.626c-6.86,3.479-13.374,7.587-19.863,11.7l1.01-.273a8.59,8.59,0,0,1-4.345-1.908,5.951,5.951,0,0,1-.952-.811c-.251-.282.129.151.129.17,0-.08-.09-.239-.079-.332a3.239,3.239,0,0,1,.258-1.121c.859-1.818,2.8-3.177,4.337-4.384q2.279-1.788,4.64-3.464a117.237,117.237,0,0,1,21.4-12.157,115.066,115.066,0,0,1,14.645-5.14c2.474-.695,1.423-4.555-1.064-3.857Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M62.665,411.746a52,52,0,0,1,10.409,3.675,117.363,117.363,0,0,1,11.47,5.936c2.222,1.31,4.237-2.147,2.019-3.454a117.021,117.021,0,0,0-11.8-6.085,56.077,56.077,0,0,0-11.032-3.929c-2.511-.531-3.584,3.324-1.063,3.857Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M64.628,422.759a39.541,39.541,0,0,1,8.575,3.224,66.882,66.882,0,0,1,8.2,4.528,2,2,0,1,0,2.018-3.454,67.258,67.258,0,0,0-8.429-4.638,43.984,43.984,0,0,0-9.3-3.517,2.046,2.046,0,0,0-2.46,1.4,2.02,2.02,0,0,0,1.4,2.46Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M63.433,421.84a107.942,107.942,0,0,1,12.1,21.087c.414.924.823,1.852,1.216,2.785.2.482.379.983.6,1.457.015.032.031.086.04.106-.153-.316.481-.055-.058-.2a4.947,4.947,0,0,0-1.477.331c-.575.129-1.147.27-1.721.4a2.613,2.613,0,0,1-1.809-.068c.283.242-.3-.49-.346-.556l-.4-.616-1.063-1.641q-1.123-1.736-2.251-3.47-2.072-3.186-4.167-6.357c-2.8-4.217-5.632-8.415-8.687-12.449a2.066,2.066,0,0,0-2.737-.718,2.014,2.014,0,0,0-.717,2.736c3.1,4.1,5.978,8.361,8.815,12.643q2.436,3.679,4.832,7.385,1.129,1.738,2.255,3.48a8.312,8.312,0,0,0,2.651,3.109c2.2,1.226,4.565.391,6.833-.117a5.347,5.347,0,0,0,3.122-1.434,3.739,3.739,0,0,0,.785-3.48,50.856,50.856,0,0,0-3.053-7.08c-.971-2.1-1.987-4.186-3.069-6.236a95.873,95.873,0,0,0-8.241-13.116,2.064,2.064,0,0,0-2.736-.717,2.013,2.013,0,0,0-.717,2.736Z"
            ></path>
            <path
              class="b"
              fill="#211715"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M95.935,368.088a30.682,30.682,0,0,1-8.158,3.9,101.7,101.7,0,0,1-11.305,3.176,117.1,117.1,0,0,1-20.6,2.641,83.261,83.261,0,0,1-26.354-2.728c-4.288-1.218-8.525-2.722-12.078-5.489a23.085,23.085,0,0,1-7.511-9.6c-1.719-4.521-2.063-10.007.37-14.333,1.526-2.714,3.8-3.988,6.363-5.513,2.21-1.316.2-4.776-2.019-3.454-2.382,1.418-4.664,2.685-6.416,4.914A18.5,18.5,0,0,0,4.754,355.4c1.17,9.358,7.809,17.34,16.43,21,16.282,6.9,35.3,6.633,52.434,3.428a108.558,108.558,0,0,0,13.52-3.411c3.7-1.2,7.655-2.549,10.816-4.874a2.061,2.061,0,0,0,.717-2.737,2.014,2.014,0,0,0-2.736-.717Z"
            ></path>
            <path
              class="d"
              fill="#d9d9d9"
              stroke="#515f76"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="3.7960000000000003"
              d="M145.65,188.524,169.6,196.2c1.981.634,3.962,1.387,5.974,1.913,1.2.314,2.345-.284,3.472-.672q4.52-1.557,9.031-3.135,18.607-6.483,37.2-13.015l15.229-5.343a2.019,2.019,0,0,0,0-3.857c-6.621-2.482-13.424-4.508-20.172-6.611q-2.664-.829-5.331-1.647c-1.27-.387-3.068-1.284-4.4-1.122a27.137,27.137,0,0,0-4.493,1.353q-20.415,6.356-40.833,12.695L145.487,182.9a2.027,2.027,0,0,0-1.468,1.928l.163,1.764a2.054,2.054,0,0,0,2,2,2.015,2.015,0,0,0,2-2l-.163-1.764-1.469,1.929,26.275-8.166q14.96-4.648,29.918-9.3,4.325-1.346,8.649-2.693h-1.064c9.751,2.873,19.589,5.775,29.11,9.344v-3.857q-24.536,8.61-49.08,17.191c-4.848,1.692-9.693,3.4-14.555,5.048h1.063l-30.152-9.659C144.256,183.879,143.2,187.74,145.65,188.524Z"
            ></path>
          </g>
        </svg>
      ),
      title: "Medical Insurance",
    },
    {
      id: 4,
      svg: (
        <svg
          class="svg-path"
          height="100px"
          width="100px"
          fill="#000000"
          viewBox="0 0 512 512"
          id="Capa_1"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xlink="http://www.w3.org/1999/xlink"
          stroke="#000000"
          stroke-width="4.096"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <path
                class="path"
                fill="red"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M331.2,120.1l24.4,0c11.6,0,21.1-8.9,21.6-20.2c0.5-10.4-6.6-19.5-16.6-21.7c-2.2-10-11.3-17.2-21.7-16.6 c-11.3,0.5-20.2,10-20.2,21.6v24.4C318.7,114.4,324.3,120.1,331.2,120.1z"
              ></path>{" "}
              <path
                class="path"
                fill="red"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M155.2,121.7c2.4,2.4,5.5,3.7,8.8,3.7s6.5-1.3,8.8-3.7l10.2-10.2c6.3-6.3,6.5-16.6,0.5-22.9c-5.1-5.3-13.2-6.4-19.6-2.9 c-6.3-3.5-14.4-2.4-19.6,2.9c-6.1,6.3-5.9,16.6,0.5,22.9L155.2,121.7z"
              ></path>{" "}
              <path
                class="path"
                fill="blue"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M144.2,311.1H73.1V151.7c0-8.3-6.7-15-15-15c-1.8,0-3.4,0.3-5,0.9v-27.8c0-2.8-2.2-5-5-5s-5,2.2-5,5v42v164.5v20v109.3 c0,2.8,2.2,5,5,5s5-2.2,5-5V336.1v-15h91.1c2.8,0,5,2.2,5,5s-2.2,5-5,5H78.1c-2.8,0-5,2.2-5,5s2.2,5,5,5h66.1c1.8,0,3.4-0.3,5-0.9 v105.2c0,2.8,2.2,5,5,5s5-2.2,5-5V326.1C159.2,317.9,152.5,311.1,144.2,311.1z M63.1,311.1h-10V151.7c0-2.8,2.2-5,5-5s5,2.2,5,5 V311.1z"
              ></path>{" "}
              <path
                class="path"
                fill="blue"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M463.9,104.7c-2.8,0-5,2.2-5,5v27.8c-1.6-0.6-3.2-0.9-5-0.9c-8.3,0-15,6.7-15,15v159.5h-71.1c-8.3,0-15,6.7-15,15v119.3 c0,2.8,2.2,5,5,5s5-2.2,5-5V340.3c1.6,0.6,3.2,0.9,5,0.9h66.1c2.8,0,5-2.2,5-5s-2.2-5-5-5h-66.1c-2.8,0-5-2.2-5-5s2.2-5,5-5h91.1 v15v109.3c0,2.8,2.2,5,5,5s5-2.2,5-5V336.1v-20V151.7v-42C468.9,106.9,466.7,104.7,463.9,104.7z M458.9,311.1h-10V151.7 c0-2.8,2.2-5,5-5s5,2.2,5,5V311.1z"
              ></path>{" "}
              <path
                class="path"
                fill="green"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M355.1,286.4H377c1.3,0,2.4,1.1,2.4,2.4c0,6.8,5.6,12.4,12.4,12.4h21.9c6.8,0,12.4-5.6,12.4-12.4v-47.5c0-2.8-2.2-5-5-5 h-18.4v-47.2c0-2.8-2.2-5-5-5h-5v-11.3c6.6-2.7,11.1-10.6,11.1-20.5c0-9.8-5-23.2-13.3-28.8c-1.7-1.1-3.8-1.1-5.5,0 c-8.3,5.5-13.3,19-13.3,28.8c0,9.9,4.5,17.8,11.1,20.5v11.3h-5c-2.8,0-5,2.2-5,5v47.2h-74.8v-10h30.5c13.6,0,24.6-11.1,24.6-24.6 c0-2.8-2.2-5-5-5h-8.8c-2.3-39-31.6-70.9-69.5-77.2c0.8-1.9,1.3-4,1.3-6.1c0-8.3-6.7-15-15-15s-15,6.7-15,15c0,2.2,0.5,4.3,1.3,6.1 c-37.9,6.3-67.2,38.2-69.5,77.2H164c-2.8,0-5,2.2-5,5c0,13.6,11.1,24.6,24.6,24.6h30.5v10h-74.8v-47.2c0-2.8-2.2-5-5-5h-5v-11.3 c6.6-2.7,11.1-10.6,11.1-20.5c0-9.8-5-23.3-13.3-28.8c-1.7-1.1-3.8-1.1-5.5,0c-8.3,5.5-13.3,18.9-13.3,28.8 c0,9.9,4.5,17.8,11.1,20.5v11.3h-5c-2.8,0-5,2.2-5,5v47.2H90.9c-2.8,0-5,2.2-5,5v47.5c0,6.8,5.6,12.4,12.4,12.4h21.9 c6.8,0,12.4-5.6,12.4-12.4c0-1.3,1.1-2.4,2.4-2.4h21.9c1.3,0,2.4,1.1,2.4,2.4c0,6.8,5.6,12.4,12.4,12.4h21.9 c6.8,0,12.4-5.6,12.4-12.4c0-1.3,1.1-2.4,2.4-2.4h5.1l37.1,83.6L218,443.5c-1.1,2.5,0,5.5,2.5,6.6c0.7,0.3,1.3,0.4,2,0.4 c1.9,0,3.7-1.1,4.6-3l28.9-65.1l28.9,65.1c0.8,1.9,2.7,3,4.6,3c0.7,0,1.4-0.1,2-0.4c2.5-1.1,3.7-4.1,2.5-6.6l-32.5-73.4l37.1-83.6 h5.1c1.3,0,2.4,1.1,2.4,2.4c0,6.8,5.6,12.4,12.4,12.4h21.9c6.8,0,12.4-5.6,12.4-12.4C352.7,287.5,353.8,286.4,355.1,286.4z M382.7,194.1h10v42.1h-10V194.1z M302.4,155.3c0-0.3,0.1-0.6,0.2-1c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.3,0.4-0.5,0.6-0.8 c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.2,0.5-0.4,0.8-0.5c0.3-0.1,0.6-0.3,0.9-0.3c0.3-0.1,0.6-0.1,1-0.2c1.6-0.1,3.3,0.7,4.3,2 c0.2,0.3,0.4,0.5,0.5,0.8c0.2,0.3,0.3,0.6,0.3,0.9c0.1,0.3,0.1,0.6,0.2,1c0,0.3,0,0.7,0,1c0,0.3-0.1,0.6-0.2,0.9 c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.3,0.5-0.6,0.8c-0.2,0.2-0.5,0.5-0.7,0.7c-1,0.8-2.4,1.2-3.7,1c-0.3,0-0.6-0.1-1-0.2 c-0.3-0.1-0.6-0.2-0.9-0.4c-0.3-0.2-0.6-0.4-0.8-0.6c-0.2-0.2-0.5-0.5-0.7-0.7c-0.2-0.3-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.3-0.9 c-0.1-0.3-0.1-0.6-0.1-1C302.4,156,302.4,155.6,302.4,155.3z M286.4,142.8c0.2-1.3,0.9-2.5,1.9-3.3c0.3-0.2,0.5-0.4,0.8-0.5 c0.3-0.1,0.6-0.3,0.9-0.3c0.3-0.1,0.6-0.1,1-0.2c0.7,0,1.3,0.1,1.9,0.3c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.2,0.6,0.4,0.8,0.6 c0.2,0.2,0.5,0.5,0.7,0.7c0.8,1,1.1,2.4,1,3.7c0,0.3-0.1,0.6-0.2,1c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.4,0.5-0.6,0.8 c-0.2,0.3-0.5,0.5-0.7,0.7c-0.3,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.3-0.9,0.3c-0.3,0.1-0.6,0.1-1,0.2c-0.3,0-0.7,0-1,0 c-0.3,0-0.6-0.1-1-0.2c-0.3-0.1-0.6-0.2-0.9-0.4c-0.3-0.2-0.5-0.4-0.8-0.6c-0.3-0.2-0.5-0.5-0.7-0.7c-0.2-0.3-0.4-0.5-0.5-0.8 c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3-0.1-0.6-0.1-1C286.4,143.5,286.4,143.2,286.4,142.8z M267.2,136.6c0-0.3,0.1-0.6,0.2-1 c0.1-0.3,0.2-0.6,0.4-0.9c0.2-0.3,0.4-0.6,0.6-0.8s0.5-0.5,0.7-0.7c0.3-0.2,0.5-0.4,0.8-0.5c0.3-0.1,0.6-0.2,0.9-0.3 c0.3-0.1,0.6-0.1,1-0.1c1.7-0.1,3.3,0.7,4.3,2c0.2,0.3,0.4,0.5,0.5,0.8c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.1,0.6,0.1,1 c0,0.3,0,0.7,0,1c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.2,0.6-0.4,0.9c-0.2,0.3-0.4,0.5-0.6,0.8c-0.2,0.3-0.5,0.5-0.7,0.7 c-1.1,0.8-2.4,1.1-3.7,1c-1.3-0.2-2.5-0.9-3.3-1.9c-0.2-0.3-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3-0.1-0.6-0.1-1 C267.1,137.3,267.1,136.9,267.2,136.6z M183.6,216.4c-6.3,0-11.7-4-13.8-9.6h7.8c2.8,0,5-2.2,5-5h20c0,2.8,2.2,5,5,5h134.5 c-2,5.6-7.4,9.6-13.8,9.6h-35.5h-73.7H183.6z M287.9,226.4v10h-63.7v-10H287.9z M119.3,194.1h10v42.1h-10V194.1z M256,357.7 l-31.6-71.3h5.9c1.3,0,2.4,1.1,2.4,2.4c0,6.8,5.6,12.4,12.4,12.4h21.9c6.8,0,12.4-5.6,12.4-12.4c0-1.3,1.1-2.4,2.4-2.4h5.9 L256,357.7z M342.7,288.8c0,1.3-1.1,2.4-2.4,2.4h-21.9c-1.3,0-2.4-1.1-2.4-2.4c0-6.8-5.6-12.4-12.4-12.4h-21.9 c-6.8,0-12.4,5.6-12.4,12.4c0,1.3-1.1,2.4-2.4,2.4h-21.9c-1.3,0-2.4-1.1-2.4-2.4c0-6.8-5.6-12.4-12.4-12.4h-21.9 c-6.8,0-12.4,5.6-12.4,12.4c0,1.3-1.1,2.4-2.4,2.4h-21.9c-1.3,0-2.4-1.1-2.4-2.4c0-6.8-5.6-12.4-12.4-12.4H135 c-6.8,0-12.4,5.6-12.4,12.4c0,1.3-1.1,2.4-2.4,2.4H98.3c-1.3,0-2.4-1.1-2.4-2.4v-42.5h123.2h73.7h123.2v42.5c0,1.3-1.1,2.4-2.4,2.4 h-21.9c-1.3,0-2.4-1.1-2.4-2.4c0-6.8-5.6-12.4-12.4-12.4h-21.9C348.3,276.4,342.7,282,342.7,288.8z"
              ></path>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
      title: "Get Together & Team Outing",
    },
    {
      id: 5,
      svg: (
        <svg
          height="100px"
          width="100px"
          fill="#000000"
          viewBox="0 0 64 64"
          data-name="Layer 1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <title></title>
            <rect
              fill="green"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              height="8"
              width="8"
              x="6"
              y="54"
            ></rect>
            <rect
              fill="yellow"
              //  stroke="#515f76"
              stroke-width="1.7960000000000003"
              height="11"
              width="8"
              x="21"
              y="51"
            ></rect>
            <rect
              fill="blue"
              //  stroke="#515f76"
              stroke-width="1.7960000000000003"
              height="15"
              width="8"
              x="36"
              y="47"
            ></rect>
            <rect
              fill="pink"
              //  stroke="#515f76"
              stroke-width="1.7960000000000003"
              height="24"
              width="8"
              x="51"
              y="38"
            ></rect>
            <rect
              fill="skyblue"
              stroke-width="1.7960000000000003"
              height="10"
              width="4.5"
              x="39"
              y="18"
            ></rect>
            <rect
              fill="skyblue"
              stroke-width="1.7960000000000003"
              height="10"
              width="3"
              x="44.5"
              y="18"
            ></rect>
            <rect
              fill="skyblue"
              stroke-width="1.7960000000000003"
              height="10"
              width="4.5"
              x="48.5"
              y="18"
            ></rect>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M30.00146,17.9502l-.002.08007L32,18a14.02975,14.02975,0,0,1,.46582-3.59473l-1.93359-.51269A15.88629,15.88629,0,0,0,30.00146,17.9502Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M46.01514,34,46,32a14.03255,14.03255,0,0,1-3.6084-.46924L41.877,33.46338A16.04749,16.04749,0,0,0,46,34Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M41.81494,2.55322a15.905,15.905,0,0,0-3.85351,1.60987L38.96729,5.8916a13.90736,13.90736,0,0,1,3.36914-1.40771Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M59.52686,21.62256l1.93261.51562A16.057,16.057,0,0,0,62,18v-.06055L60,18A14.04072,14.04072,0,0,1,59.52686,21.62256Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M59.82861,9.94727l-1.72754,1.00781a13.92209,13.92209,0,0,1,1.41114,3.36767l1.92968-.52441A15.90937,15.90937,0,0,0,59.82861,9.94727Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M57.27393,6.647a16.03853,16.03853,0,0,0-3.31934-2.53174l-.99512,1.73438a14.04964,14.04964,0,0,1,2.90528,2.21631Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M30.54932,22.17041a15.91558,15.91558,0,0,0,1.606,3.855l1.7295-1.00488A13.883,13.883,0,0,1,32.481,21.65088Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M50.0918,2.52832A16.03746,16.03746,0,0,0,46,2h-.04541L46,4a14.03208,14.03208,0,0,1,3.581.46191Z"
            ></path>
            <path
              fill="red"
              // stroke="#515f76"
              stroke-width="1.7960000000000003"
              d="M58.12939,24.99609a14.04627,14.04627,0,0,1-2.22558,2.89844l1.415,1.41406a16.06769,16.06769,0,0,0,2.542-3.31152Z"
            ></path>
            <path
              fill="red"
              stroke-width="1.7960000000000003"
              d="M54.01123,31.853,53.0083,30.12256a13.91241,13.91241,0,0,1-3.37158,1.40088l.51855,1.93164A15.93177,15.93177,0,0,0,54.01123,31.853Z"
            ></path>
            <path
              fill="red"
              stroke-width="1.7960000000000003"
              d="M33.85645,11.02832a14.04574,14.04574,0,0,1,2.21972-2.90283l-1.418-1.41113a16.07144,16.07144,0,0,0-2.53515,3.31591Z"
            ></path>
            <path
              fill="red"
              stroke-width="1.7960000000000003"
              d="M34.70312,29.33008a16.04284,16.04284,0,0,0,3.31348,2.53857l.999-1.73242a14.06851,14.06851,0,0,1-2.90039-2.22217Z"
            ></path>
            <path
              fill="white"
              stroke-width="1.7960000000000003"
              d="M14.27051,41H24a1.00071,1.00071,0,0,0,.6001-.2002l6.00311-4.50231-.58954,3.538,1.97266.3291,1-6a1.0001,1.0001,0,0,0-.82178-1.15088l-6-1-.3291,1.97266,3.69519.61572L23.6665,39H14a.998.998,0,0,0-.50391.13623l-12,7,1.00782,1.72754Z"
            ></path>
            <path
              fill="skyblue"
              stroke-width="1.7960000000000003"
              d="M47.5,12l1.56641-2.16748a1.07439,1.07439,0,0,1,1.88232,1.0332L50,12H48.5v5H55V12H52.618l.11981-.23975a3.07454,3.07454,0,0,0-5.38623-2.957l-1.31982,2.2-1.31983-2.2a3.07456,3.07456,0,0,0-5.38623,2.957L39.4455,12H37v5h6.5V12H42l-.88525-1.13428a1.0744,1.0744,0,0,1,1.88232-1.0332L44.5,12v5h3Z"
            ></path>
          </g>
        </svg>
      ),
      title: "Best Incentive & Rewards",
    },
    {
      id: 6,
      svg: (
        <svg
          height="100px"
          width="100px"
          viewBox="0 0 64 64"
          data-name="Layer 1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          stroke="#000000"
          stroke-width="2.7897299999999996"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            // stroke-linecap="round"
            // stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <defs></defs>
            <path
              class="cls-6"
              fill="#a3cef1"
              stroke-width="3.7960000000000003"
              d="M29.72,20.65h0c2.65-4.29,7.38-7.15,12.78-7.15,8.28,0,15,6.72,15,15,0,4.47-1.95,8.48-5.06,11.23h-.01s.01,0,.01,0l.06-.23h-18.86c-1.82-1.85-4.35-3-7.14-3h-3v-2.29s1.58-.67,1.58-.67c1.47-.63,2.42-2.08,2.42-3.68v-.76l2.2-.44c.46-.09,.8-.5,.8-.98v-1.45c.29,.17,.64,.27,1,.27,1.1,0,2-.9,2-2s-.9-2-2-2c-.42,0-.81,.13-1.14,.36-.12-.77-.34-1.51-.64-2.21h0"
            ></path>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1"
              height="8"
              width="2"
              x="41.5"
              y="18.5"
            ></rect>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1"
              height="6.06"
              transform="translate(-10.38 26.69) rotate(-29.78)"
              width="2"
              x="43.99"
              y="29.84"
            ></rect>
            <path
              class="cls-7"
              fill="#dda15e"
              stroke-width="1.7960000000000003"
              d="M25.08,33.54l-3,1.29c-1.01,.43-2.15,.43-3.15,0l-3-1.29c-1.47-.63-2.42-2.08-2.42-3.68v-5.36c0-3.31,2.69-6,6-6h2c3.31,0,6,2.69,6,6v5.36c0,1.6-.95,3.05-2.42,3.68Z"
            ></path>
            <path
              class="cls-9"
              fill="#274c77"
              stroke-width="1.7960000000000003"
              d="M33.64,39.5c-1.82-1.85-4.35-3-7.14-3h-3c0,1.66-1.34,3-3,3s-3-1.34-3-3h-3c-5.52,0-10,4.48-10,10v7H26.5l4-14h3.14Z"
            ></path>
            <path
              class="cls-7"
              fill="#dda15e"
              stroke-width="1.7960000000000003"
              d="M15.5,49.5h2c1.1,0,2,.9,2,2v2h-4v-4h0Z"
            ></path>
            <path
              class="cls-9"
              fill="#274c77"
              stroke-width="1.7960000000000003"
              d="M10.5,26.23c-.29,.17-.64,.27-1,.27-1.1,0-2-.9-2-2s.9-2,2-2c.42,0,.81,.13,1.14,.36"
            ></path>
            <path
              class="cls-9"
              fill="#274c77"
              stroke-width="1.7960000000000003"
              d="M30.5,26.23c.29,.17,.64,.27,1,.27,1.1,0,2-.9,2-2s-.9-2-2-2c-.42,0-.81,.13-1.14,.36"
            ></path>
            <path
              class="cls-5"
              fill="#bc6c25"
              stroke-width="1.7960000000000003"
              d="M17.5,34.21l1.42,.61c1.01,.44,2.15,.44,3.16,0l1.42-.61v2.29c0,1.66-1.34,3-3,3s-3-1.34-3-3v-2.29Z"
            ></path>
            <polyline
              class="cls-4"
              fill="#8b8c89"
              stroke-width="1.7960000000000003"
              points="26.5 53.5 30.5 39.5 52.5 39.5 48.5 53.5"
            ></polyline>
            <path
              class="cls-9"
              fill="#274c77"
              stroke-width="1.7960000000000003"
              d="M26.9,21.88h-.01c-.57-.23-1.23-.38-2.06-.38-4.33,0-4.33,4-8.67,4-1.13,0-1.97-.27-2.66-.67v-.33c0-3.31,2.69-6,6-6h2c2.37,0,4.42,1.38,5.39,3.38h.01Z"
            ></path>
            <path
              class="cls-2"
              fill="#e7ecef"
              stroke-width="1.7960000000000003"
              d="M27.5,29.1v-4.6c0-3.31-2.69-6-6-6h-2c-3.31,0-6,2.69-6,6v4h-2c-.55,0-1-.45-1-1v-3c0-5.52,4.48-10,10-10,2.76,0,5.26,1.12,7.07,2.93s2.93,4.31,2.93,7.07v3.18c0,.48-.34,.89-.8,.98l-2.2,.44Z"
            ></path>
            <path
              class="cls-6"
              fill="#a3cef1"
              stroke-width="1.7960000000000003"
              d="M39.5,45.5c.55,0,1,.45,1,1s-.45,1-1,1v-2Z"
            ></path>
            <path
              class="cls-8"
              fill="#6096ba"
              stroke-width="1.7960000000000003"
              d="M20.5,53.5h-2v-2c0-.55-.45-1-1-1h-7c-.55,0-1-.45-1-1v-4c0-.27,.11-.52,.29-.71l1.29-1.29c.39-.39,1.02-.39,1.41,0h0c.39,.39,.39,1.02,0,1.41l-1,1v2.59h6c1.66,0,3,1.34,3,3v2Z"
            ></path>
            <rect
              class="cls-6"
              fill="#a3cef1"
              stroke-width="1.7960000000000003"
              height="2"
              width="50"
              x="2.5"
              y="52.5"
            ></rect>
            <circle
              class="cls-3"
              fill="#ffbc0a"
              stroke-width="1.7960000000000003"
              cx="42.5"
              cy="28.5"
              r="2"
            ></circle>
            <path
              class="cls-9"
              fill="#274c77"
              stroke-width="1.7960000000000003"
              d="M42.5,31.5c-1.65,0-3-1.35-3-3s1.35-3,3-3,3,1.35,3,3-1.35,3-3,3Zm0-4c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1-.45-1-1-1Z"
            ></path>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1.7960000000000003"
              height="2"
              width="2"
              x="41.5"
              y="13.5"
            ></rect>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1.7960000000000003"
              height="2"
              transform="translate(-3.43 19.95) rotate(-30)"
              width="2"
              x="34.5"
              y="15.38"
            ></rect>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1.7960000000000003"
              height="2"
              transform="translate(-3.43 65.05) rotate(-60)"
              width="2"
              x="53.62"
              y="34.5"
            ></rect>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1.7960000000000003"
              height="2"
              width="2"
              x="55.5"
              y="27.5"
            ></rect>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1.7960000000000003"
              height="2"
              transform="translate(-3.43 30.19) rotate(-29.99)"
              width="2"
              x="53.62"
              y="20.5"
            ></rect>
            <rect
              class="cls-1"
              fill="#f5dd90"
              stroke-width="1.7960000000000003"
              height="2"
              transform="translate(10.57 51.06) rotate(-60.01)"
              width="2"
              x="48.5"
              y="15.38"
            ></rect>
            <path
              class="cls-9"
              fill="#274c77"
              stroke-width="1.7960000000000003"
              d="M52.44,39.73h-.01s-1.67,5.88-1.67,5.88h0c6.35-3.07,10.74-9.57,10.74-17.11,0-10.49-8.51-19-19-19-6.24,0-11.77,3.01-15.23,7.65,.1,.09,.2,.18,.3,.28,.91,.91,1.65,2,2.15,3.21h0s0,0,0,0c2.65-4.28,7.38-7.14,12.78-7.14,8.28,0,15,6.72,15,15,0,4.47-1.95,8.48-5.06,11.23h-.01"
            ></path>
            <path
              class="cls-8"
              fill="#6096ba"
              stroke-width="1.7960000000000003"
              d="M20.5,30.5h0c-.11-.54,.24-1.07,.78-1.18l8.22-1.64v-2.86c0-4.79-3.61-8.98-8.38-9.3-5.24-.35-9.62,3.81-9.62,8.98v3h2v2h-2c-1.1,0-2-.9-2-2v-2.68c0-5.72,4.24-10.74,9.94-11.27,6.54-.62,12.06,4.53,12.06,10.95v3.18c0,.95-.67,1.77-1.61,1.96l-8.22,1.64c-.54,.11-1.07-.24-1.18-.78Z"
            ></path>
          </g>
        </svg>
      ),
      title: "Flexible Working Hours",
    },
    {
      id: 7,
      svg: (
        <svg
          height="100px"
          width="100px"
          fill="#000000"
          viewBox="0 0 256 256"
          id="Layer_1"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          {" "}
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <path
                fill="#bc6c25"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M116.1,26.9h4.3v76.7c0,5.9,4.8,10.7,10.7,10.7H233c5.9,0,10.7-4.8,10.7-10.7V26.9h4.3c2.8,0,5-2.3,5-5s-2.3-5-5-5h-8.8 c-0.2,0-0.4-0.1-0.5-0.1c-0.2,0-0.4,0.1-0.5,0.1H126c-0.2,0-0.4-0.1-0.5-0.1c-0.2,0-0.4,0.1-0.5,0.1h-8.8c-2.8,0-5,2.3-5,5 S113.3,26.9,116.1,26.9z M233.7,103.6c0,0.4-0.3,0.7-0.7,0.7H131.1c-0.4,0-0.7-0.3-0.7-0.7V26.9h103.2V103.6z"
              ></path>{" "}
              <path
                fill="#bc6c25"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M243.7,206.3c-6.6-3.3-18.6-7.6-24.5-9.6v-0.2c3.1-2.8,5.3-6.4,6.6-10.4c3.2-1,5.9-3.4,7.3-6.6c0.9-1.8,1.4-3.8,1.4-5.8 c0-1.4-0.2-2.7-0.7-4c-0.4-1.6-1.2-3-2.3-4.1c1.2-7.2-0.6-14.5-5.1-20.2c-5.1-6.6-13-10.5-21.6-10.7c-0.4,0-0.8,0-1,0 c-0.4,0-0.8,0-1.3,0c-8.6,0.2-16.5,4.1-21.6,10.7c-4.5,5.8-6.3,13.1-5.1,20.2c-1.1,1.1-1.9,2.5-2.3,4.1c-0.5,1.3-0.7,2.6-0.7,4 c0,2,0.5,4,1.4,5.8c1.4,3.2,4.1,5.6,7.3,6.6c1.2,4,3.5,7.6,6.6,10.4v0.2c-5.2,1.8-15.3,5.4-22.3,8.6c-6.8-3.1-17-6.8-22.3-8.6v-0.2 c3.1-2.8,5.3-6.4,6.6-10.4c3.2-1,5.9-3.4,7.3-6.6c0.9-1.8,1.4-3.8,1.4-5.8c0-1.4-0.2-2.7-0.7-4c-0.4-1.6-1.2-3-2.3-4.1 c1.2-7.2-0.6-14.5-5.1-20.2c-5.1-6.6-13-10.5-21.6-10.7c-0.4,0-0.8,0-1,0c-0.4,0-0.8,0-1.3,0c-8.6,0.2-16.5,4.1-21.6,10.7 c-4.5,5.8-6.3,13.1-5.1,20.2c-1.1,1.1-1.9,2.5-2.3,4.1c-0.5,1.3-0.7,2.6-0.7,4c0,2,0.5,4,1.4,5.8c1.4,3.2,4.1,5.6,7.3,6.6 c1.2,4,3.5,7.6,6.6,10.4v0.2c-5.3,1.8-15.4,5.5-22.3,8.6c-6.8-3.1-17-6.8-22.3-8.6v-0.2c3.1-2.8,5.3-6.4,6.6-10.4 c3.2-1,5.9-3.4,7.3-6.6c0.9-1.8,1.4-3.8,1.4-5.8c0-1.4-0.2-2.7-0.7-4c-0.4-1.6-1.2-3-2.3-4.1c1.2-7.2-0.6-14.5-5.1-20.2 c-5.1-6.6-13-10.5-21.6-10.7c-0.4,0-0.8,0-1,0c-0.4,0-0.8,0-1.3,0c-8.6,0.2-16.5,4.1-21.6,10.7c-4.5,5.8-6.3,13.1-5.1,20.2 c-1.1,1.1-1.9,2.5-2.3,4.1c-0.5,1.3-0.7,2.6-0.7,4c0,2,0.5,4,1.4,5.8c1.4,3.2,4.1,5.6,7.3,6.6c1.2,4,3.5,7.6,6.6,10.4v0.2 c-5.9,2-17.9,6.4-24.5,9.6c-4,2-6.9,5.8-7.6,10.3c-1.5,8.8-1.8,23.1-1.8,23.7c0,2.8,2.2,5.1,5,5.1c0,0,0.1,0,0.1,0c2.7,0,5-2.2,5-5 c0-0.1,0.3-14.1,1.6-22.2c0.2-1.3,1-2.4,2.2-3c8.1-4,26.4-10.2,26.6-10.3c2.1-0.7,3.4-2.6,3.4-4.8v-6.2c0-1.6-0.7-3.1-2-4l-0.5-0.4 c-2.6-1.9-4.3-4.9-4.9-8.1l-0.1-0.7c-0.4-2.5-2.5-4.3-5-4.3h-0.5c-0.9,0-1.5-0.6-1.7-1.2c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.2,0-0.5,0.1-0.7c0-0.1,0.1-0.2,0.1-0.2l1-0.6c1.9-1.1,2.8-3.3,2.3-5.4l-0.4-1.9 c-1.1-4.7-0.1-9.5,2.9-13.3c3.2-4.2,8.3-6.6,13.9-6.8l1,0l0.8,0c5.6,0.1,10.6,2.6,13.9,6.8c3,3.8,4,8.5,2.9,13.3l-0.4,1.9 c-0.5,2.1,0.4,4.3,2.3,5.4l1,0.6c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2,0.1,0.5,0.1,0.7c0,0.4-0.1,0.8-0.3,1.2c-0.1,0.2-0.2,0.4-0.3,0.5 c-0.2,0.5-0.8,1.2-1.7,1.2h-0.5c-2.5,0-4.6,1.8-5,4.3l-0.1,0.7c-0.5,3.2-2.3,6.2-4.8,8.1l-0.5,0.4c-1.3,1-2,2.4-2,4v6.2 c0,2.2,1.4,4.1,3.4,4.8c0.2,0.1,18.5,6.2,26.4,10.2c1.5,0.8,3.3,0.8,4.8,0.1c8.1-4,26.4-10.2,26.6-10.3c2.1-0.7,3.4-2.6,3.4-4.8 v-6.2c0-1.6-0.7-3.1-2-4l-0.5-0.4c-2.6-1.9-4.3-4.9-4.9-8.1l-0.1-0.7c-0.4-2.5-2.5-4.3-5-4.3h-0.5c-0.9,0-1.5-0.6-1.7-1.2 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.2,0-0.5,0.1-0.7c0-0.1,0.1-0.2,0.1-0.2l1-0.6c1.9-1.1,2.8-3.3,2.3-5.4 l-0.4-1.9c-1.1-4.7-0.1-9.5,2.9-13.3c3.2-4.2,8.3-6.6,13.9-6.8l1,0l0.8,0c5.6,0.1,10.6,2.6,13.9,6.8c3,3.8,4,8.5,2.9,13.3l-0.4,1.9 c-0.5,2.1,0.4,4.3,2.3,5.4l1,0.6c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2,0.1,0.5,0.1,0.7c0,0.4-0.1,0.8-0.3,1.2c-0.1,0.2-0.2,0.3-0.3,0.5 c-0.2,0.5-0.8,1.2-1.7,1.2h-0.5c-2.5,0-4.6,1.8-5,4.3l-0.1,0.7c-0.5,3.2-2.3,6.2-4.9,8.1l-0.5,0.4c-1.3,1-2,2.4-2,4v6.2 c0,2.2,1.4,4.1,3.4,4.8c0.2,0.1,18.5,6.2,26.6,10.3c1.4,0.8,3.2,0.7,4.7,0c8.1-4,26.4-10.2,26.6-10.3c2.1-0.7,3.4-2.6,3.4-4.8v-6.2 c0-1.6-0.7-3.1-2-4l-0.5-0.4c-2.6-1.9-4.3-4.9-4.9-8.1l-0.1-0.7c-0.4-2.5-2.5-4.3-5-4.3h-0.5c-0.9,0-1.5-0.6-1.7-1.2 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.2,0-0.5,0.1-0.7c0-0.1,0.1-0.2,0.1-0.2l1-0.6c1.9-1.1,2.8-3.3,2.3-5.4 l-0.4-1.9c-1.1-4.7-0.1-9.5,2.9-13.3c3.2-4.2,8.3-6.6,13.9-6.8l1,0l0.8,0c5.6,0.1,10.6,2.6,13.9,6.8c3,3.8,4,8.5,2.9,13.3l-0.4,1.9 c-0.5,2.1,0.4,4.3,2.3,5.4l1,0.6c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2,0.1,0.5,0.1,0.7c0,0.4-0.1,0.8-0.3,1.2c-0.1,0.2-0.2,0.4-0.3,0.5 c-0.2,0.5-0.8,1.2-1.7,1.2h-0.5c-2.5,0-4.6,1.8-5,4.3l-0.1,0.7c-0.5,3.2-2.3,6.2-4.8,8.1l-0.5,0.4c-1.3,1-2,2.4-2,4v6.2 c0,2.2,1.4,4.1,3.4,4.8c0.2,0.1,18.5,6.2,26.6,10.3c1.2,0.6,2,1.7,2.2,2.9c1.4,8.1,1.6,22,1.6,22.2c0.1,2.8,2.5,5,5.1,5 c2.8-0.1,5-2.3,5-5.1c0-0.6-0.3-14.9-1.8-23.7C250.6,212.2,247.7,208.3,243.7,206.3z"
              ></path>{" "}
              <path
                fill="#bc6c25"
                stroke="#515f76"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="3.7960000000000003"
                d="M7.9,125.6c2.7,0.1,5.1-2.1,5.2-4.9c0.1-4.2,0.6-17.1,1.6-23c0.2-1.4,1.1-2.6,2.4-3.2c8.5-4.3,27.7-10.7,27.9-10.8 c2.1-0.7,3.4-2.6,3.4-4.8v-6.5c0-1.5-0.7-3-1.9-4l-0.6-0.5c-2.7-2.1-4.6-5.3-5.2-8.8l-0.1-0.7c-0.4-2.4-2.5-4.2-5-4.2h-0.5 c-1.1,0-1.8-0.7-2.1-1.4c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.3,0.1-0.6,0.2-0.9c0-0.1,0.1-0.2,0.1-0.3l1.1-0.6 c1.9-1.1,2.8-3.3,2.3-5.4L35.7,42c-1.2-5.1-0.1-10.1,3.1-14.1c3.4-4.4,8.8-7,14.6-7.2h2.1c5.9,0.1,11.3,2.7,14.7,7.1 c3.2,4.1,4.3,9.1,3.1,14.2l-0.4,1.9c-0.5,2.1,0.5,4.3,2.3,5.4l1,0.6c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.1,0.4,0.1,0.7 c0,0.5-0.1,1-0.3,1.3c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,0.8-1.1,1.4-2,1.4h-0.6c-2.6,0-4.7,1.9-5,4.5l0,0.5c-0.6,3.4-2.4,6.6-5.3,8.8 l-0.6,0.4c-1.2,1-1.9,2.4-1.9,4V79c0,2.2,1.4,4.1,3.4,4.8c0.2,0.1,19.4,6.5,27.9,10.8c1.3,0.6,2.2,1.8,2.4,3.2 c1,5.9,1.4,18.8,1.6,23c0.1,2.7,2.3,4.9,5,4.9c0.1,0,0.1,0,0.2,0c2.8-0.1,5-2.4,4.9-5.2c-0.3-7.7-0.7-18.5-1.7-24.3 c-0.7-4.6-3.7-8.5-7.8-10.6c-6.9-3.5-19.7-8-25.8-10.2v-0.5c3.2-2.9,5.6-6.7,6.9-10.9c3.4-1,6.2-3.5,7.6-6.8c1-1.8,1.5-3.9,1.5-6 c0-1.5-0.2-2.9-0.7-4.2c-0.4-1.6-1.2-3.1-2.4-4.2c1.3-7.5-0.6-15.2-5.3-21.2c-5.3-6.8-13.5-10.8-22.5-11h-2.3 c-8.9,0.2-17.1,4.3-22.4,11.1c-4.7,6-6.5,13.6-5.2,21.1c-1.2,1.2-2,2.6-2.5,4.2c-0.4,1.3-0.7,2.7-0.7,4.1c0,2.1,0.5,4.2,1.4,6 c1.5,3.3,4.3,5.8,7.7,6.8c1.3,4.2,3.7,8,6.9,10.9v0.5c-6.1,2.1-18.8,6.7-25.8,10.1c-4.1,2-7.1,6-7.9,10.5c-1,5.9-1.5,16.7-1.7,24.4 C2.9,123.2,5.1,125.5,7.9,125.6z"
              ></path>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
      title: "Regular Learning Sessions",
    },
    {
      id: 8,
      svg: (
        <svg
          class="svg-path"
          height="100px"
          width="100px"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="#000000"
          stroke="#000000"
          stroke-width="10.24"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <path
                  class="path"
                  style={{ fill: "#E84649" }}
                  d="M449.637,433.766l21.184,18.773c7.173,6.356,2.677,18.209-6.907,18.209H348.887 c-5.752,0-10.415-4.663-10.415-10.415v-65.872h126.648c9.429,0,14.005,11.531,7.14,17.996L449.637,433.766z"
                ></path>{" "}
                <path
                  class="path"
                  style={{ fill: "#D73337" }}
                  d="M400.397,394.461v17.007c0,13.778-11.206,24.995-24.995,24.995h-36.93v-42.002H400.397z"
                ></path>{" "}
                <path
                  class="path"
                  style={{ fill: "#E84649" }}
                  d="M173.527,394.461v65.872c0,5.752-4.663,10.415-10.415,10.415H48.086 c-9.584,0-14.08-11.852-6.907-18.209l21.184-18.773l-22.624-21.309c-6.864-6.465-2.289-17.996,7.14-17.996H173.527z"
                ></path>{" "}
                <path
                  class="path"
                  style={{ fill: "#D73337" }}
                  d="M111.603,394.461h61.925v42.002h-36.93c-13.789,0-24.995-11.216-24.995-24.995V394.461z"
                ></path>{" "}
              </g>{" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path
                    class="path"
                    style={{ fill: "#83B832" }}
                    d="M374.481,385.758c-2.911,0-5.699-1.653-7.009-4.467c-1.802-3.868-0.126-8.464,3.742-10.266 c33.86-15.77,58.795-38.031,74.11-66.165c12.287-22.572,18.538-49.087,18.578-78.806c0.07-51.416-18.694-95.031-18.883-95.466 c-1.706-3.909,0.078-8.463,3.987-10.171c3.907-1.708,8.46,0.071,10.17,3.979c0.823,1.878,20.137,46.626,20.179,101.189 c0.04,51.131-17.557,120.3-101.618,159.448C376.683,385.524,375.572,385.758,374.481,385.758z"
                  ></path>{" "}
                  <g>
                    {" "}
                    <path
                      class="path"
                      style={{ fill: "#BDEB73" }}
                      d="M452.432,67.648c8.582,24.851,10.865,60.983-0.37,64.863 c-11.236,3.88-31.736-25.96-40.318-50.811c-8.582-24.851-1.997-35.303,9.239-39.183 C432.218,38.636,443.849,42.797,452.432,67.648z"
                    ></path>{" "}
                  </g>{" "}
                  <g>
                    {" "}
                    <path
                      style={{ fill: "#9AD63B" }}
                      d="M452.058,132.506c-2.614,0.906-5.738-0.021-9.102-2.291c3.583-13.039,0.687-37.805-5.707-56.322 c-6.79-19.652-15.486-26.359-24.391-26.39c2.187-2.291,4.968-3.905,8.123-4.989c11.237-3.874,22.87,0.281,31.452,25.13 C461.015,92.504,463.296,128.632,452.058,132.506z"
                    ></path>{" "}
                  </g>{" "}
                  <g>
                    {" "}
                    <path
                      style={{ fill: "#8EC737" }}
                      d="M472.044,228.944c-5.186,3.833-15.945-0.989-27.192-9.571 c-9.488-7.248-19.329-17.163-26.484-26.838c-15.632-21.152-12.477-33.087-2.916-40.158c9.29-6.863,21.214-6.592,36.232,12.851 c0.437,0.552,0.864,1.125,1.302,1.719C468.607,188.088,481.604,221.873,472.044,228.944z"
                    ></path>{" "}
                    <path
                      style={{ fill: "#83B832" }}
                      d="M472.044,228.944c-5.186,3.833-15.945-0.989-27.192-9.571c-0.615-4.437-0.792-9.446-0.531-15.007 c0.573-12.393,3.281-26.64,7.363-39.138c0.437,0.552,0.864,1.125,1.302,1.719C468.607,188.088,481.604,221.873,472.044,228.944z "
                    ></path>{" "}
                    <path
                      style={{ fill: "#BDEB73" }}
                      d="M467.238,164.96c-9.264,24.605-12.543,60.66-1.419,64.848 c11.125,4.189,32.44-25.075,41.704-49.68c9.264-24.605,2.97-35.234-8.155-39.423 C488.245,136.517,476.503,140.355,467.238,164.96z"
                    ></path>{" "}
                    <path
                      style={{ fill: "#9AD63B" }}
                      d="M507.526,180.131c-9.269,24.599-30.577,53.864-41.71,49.677c-2.593-0.968-4.395-3.676-5.53-7.561 c11.102-7.644,24.787-28.671,31.723-47.084c7.301-19.402,4.936-30.108-1.843-35.826c3.072-0.323,6.165,0.219,9.206,1.364 C510.494,144.899,516.785,155.522,507.526,180.131z"
                    ></path>{" "}
                  </g>{" "}
                  <g>
                    {" "}
                    <path
                      style={{ fill: "#8EC737" }}
                      d="M445.216,334.912c-6.28,1.479-14.257-7.207-21.204-19.538 c-5.863-10.394-10.987-23.401-13.747-35.107c-6.02-25.588,1.593-35.326,13.164-38.044c11.258-2.645,22.11,2.312,28.234,26.12 c0.177,0.677,0.344,1.364,0.51,2.072C458.182,296.014,456.787,332.183,445.216,334.912z"
                    ></path>{" "}
                    <path
                      style={{ fill: "#83B832" }}
                      d="M445.216,334.912c-6.28,1.479-14.257-7.207-21.204-19.538c1.177-4.322,2.989-8.988,5.426-13.997 c5.426-11.164,13.539-23.172,22.225-33.035c0.177,0.677,0.344,1.364,0.51,2.072 C458.182,296.014,456.787,332.183,445.216,334.912z"
                    ></path>{" "}
                    <path
                      style={{ fill: "#BDEB73" }}
                      d="M466.051,274.221c-18.223,18.952-35.464,50.786-26.896,59.025 c8.569,8.239,39.702-10.237,57.925-29.189c18.223-18.952,16.634-31.202,8.065-39.441 C496.577,256.377,484.273,255.27,466.051,274.221z"
                    ></path>{" "}
                    <path
                      style={{ fill: "#9AD63B" }}
                      d="M497.08,304.054c-18.225,18.954-49.354,37.43-57.926,29.192 c-1.323-1.271-2.031-3.114-2.208-5.384c13.226-3.885,32.139-16.83,44.814-30.004c17.746-18.454,16.705-30.556,8.727-38.794 c5.853-0.583,10.664,1.708,14.653,5.551C513.712,272.852,515.306,285.11,497.08,304.054z"
                    ></path>{" "}
                  </g>{" "}
                </g>{" "}
                <g>
                  {" "}
                  <path
                    style={{ fill: "#83B832" }}
                    d="M137.519,385.758c-1.093,0-2.201-0.232-3.257-0.724C50.202,345.885,32.605,276.716,32.645,225.586 c0.042-54.563,19.356-99.311,20.179-101.189c1.711-3.908,6.265-5.691,10.176-3.979c3.908,1.711,5.69,6.267,3.979,10.176 c-0.293,0.675-18.952,44.189-18.881,95.461c0.04,29.719,6.292,56.233,18.578,78.806c15.315,28.134,40.249,50.395,74.11,66.165 c3.868,1.802,5.544,6.397,3.742,10.266C143.218,384.104,140.431,385.758,137.519,385.758z"
                  ></path>{" "}
                  <g>
                    {" "}
                    <path
                      style={{ fill: "#BDEB73" }}
                      d="M59.568,67.648c-8.582,24.851-10.865,60.983,0.37,64.863s31.736-25.96,40.318-50.811 s1.997-35.303-9.239-39.183S68.151,42.797,59.568,67.648z"
                    ></path>{" "}
                  </g>{" "}
                  <g>
                    {" "}
                    <path
                      style={{ fill: "#9AD63B" }}
                      d="M100.256,81.704c-8.582,24.849-29.077,54.687-40.315,50.802c-2.76-0.948-4.707-3.843-5.936-8.05 c10.935-7.821,24.172-29.39,30.64-48.115c6.478-18.767,4.312-29.327-1.979-35.024c2.77-0.229,5.572,0.24,8.352,1.198 C102.256,46.399,108.837,56.844,100.256,81.704z"
                    ></path>{" "}
                  </g>{" "}
                  <g>
                    {" "}
                    <path
                      style={{ fill: "#8EC737" }}
                      d="M39.956,228.944c5.186,3.833,15.945-0.989,27.192-9.571c9.488-7.248,19.329-17.163,26.484-26.838 c15.632-21.152,12.477-33.087,2.916-40.158c-9.29-6.863-21.214-6.592-36.232,12.851c-0.437,0.552-0.864,1.125-1.302,1.719 C43.393,188.088,30.396,221.873,39.956,228.944z"
                    ></path>{" "}
                    <path
                      style={{ fill: "#83B832" }}
                      d="M93.632,192.535c-7.155,9.675-16.996,19.59-26.484,26.838 c-11.248,8.582-22.006,13.404-27.192,9.571c-1.406-1.041-2.333-2.676-2.822-4.749c4.353-1.896,9.259-4.968,14.257-8.779 c9.488-7.249,19.329-17.163,26.484-26.838c15.382-20.808,12.57-32.702,3.374-39.804c5.738-1.354,10.831,0.302,15.299,3.604 C106.109,159.448,109.264,171.383,93.632,192.535z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#83B832" }}
                      d="M39.956,228.944c5.186,3.833,15.945-0.989,27.192-9.571c0.614-4.437,0.792-9.446,0.531-15.007 c-0.573-12.393-3.281-26.64-7.363-39.138c-0.437,0.552-0.864,1.125-1.302,1.719C43.393,188.088,30.396,221.873,39.956,228.944z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#BDEB73" }}
                      d="M44.762,164.96c9.264,24.605,12.543,60.66,1.419,64.848c-11.125,4.189-32.44-25.075-41.704-49.68 s-2.97-35.234,8.155-39.423S35.497,140.355,44.762,164.96z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#9AD63B" }}
                      d="M46.184,229.809c-2.802,1.052-6.249-0.01-9.987-2.593c4.062-12.56,0.479-38.732-6.749-57.925 c-6.592-17.496-14.424-24.485-22.402-25.557c1.645-1.271,3.53-2.26,5.582-3.031c11.123-4.187,22.87-0.344,32.129,24.255 C54.026,189.567,57.306,225.622,46.184,229.809z"
                    ></path>{" "}
                  </g>{" "}
                  <g>
                    {" "}
                    <path
                      class="path"
                      style={{ fill: "#8EC737" }}
                      d="M66.784,334.912c6.28,1.479,14.257-7.207,21.204-19.538 c5.863-10.394,10.987-23.401,13.747-35.107c6.02-25.588-1.593-35.326-13.164-38.044c-11.258-2.645-22.11,2.312-28.234,26.12 c-0.177,0.677-0.344,1.364-0.51,2.072C53.818,296.014,55.213,332.183,66.784,334.912z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#83B832" }}
                      d="M101.735,280.267c-2.76,11.706-7.884,24.714-13.747,35.107 c-6.946,12.331-14.924,21.017-21.204,19.538c-2.958-0.698-5.249-3.583-6.926-7.915c4.062-3.468,8.28-9.238,12.164-16.143 c5.863-10.394,10.987-23.401,13.747-35.107c4.364-18.538,1.562-28.765-4.707-34.014c2.447-0.312,4.968-0.104,7.509,0.489 C100.141,244.941,107.754,254.679,101.735,280.267z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#83B832" }}
                      d="M66.784,334.912c6.28,1.479,14.257-7.207,21.204-19.538c-1.177-4.322-2.989-8.988-5.426-13.997 c-5.426-11.164-13.539-23.172-22.225-33.035c-0.177,0.677-0.344,1.364-0.51,2.072C53.818,296.014,55.213,332.183,66.784,334.912 z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#BDEB73" }}
                      d="M45.949,274.221c18.223,18.952,35.464,50.786,26.896,59.025s-39.702-10.237-57.925-29.189 c-18.223-18.952-16.634-31.202-8.065-39.441S27.727,255.27,45.949,274.221z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#9AD63B" }}
                      d="M72.845,333.246c-2.739,2.635-7.79,2.541-13.987,0.562c2.302-11.821-12.935-38.367-28.921-54.989 c-8.748-9.102-16.132-13.57-22.391-14.851c8.529-7.634,20.662-8.196,38.398,10.258C64.17,293.171,81.416,325.008,72.845,333.246 z"
                    ></path>{" "}
                  </g>{" "}
                </g>{" "}
              </g>{" "}
              <path
                class="path"
                style={{ fill: "#ED6264" }}
                d="M375.407,421.883H136.593c-5.752,0-10.415-4.663-10.415-10.415v-76.383 c0-5.752,4.663-10.415,10.415-10.415h238.814c5.752,0,10.415,4.663,10.415,10.415v76.383 C385.822,417.22,381.159,421.883,375.407,421.883z"
              ></path>{" "}
              <path
                class="path"
                style={{ fill: "#E84649" }}
                d="M385.817,335.088v76.38c0,5.749-4.655,10.415-10.414,10.415H350.96 c5.759,0,10.415-4.666,10.415-10.415v-76.38c0-5.759-4.655-10.415-10.415-10.415h24.443 C381.162,324.673,385.817,329.329,385.817,335.088z"
              ></path>{" "}
              <g>
                {" "}
                <path
                  class="path"
                  style={{ fill: "#FFDBAA" }}
                  d="M294.746,318.66c0,9.538-3.453,18.286-9.174,25.036c-7.115,8.384-17.724,13.709-29.572,13.709 c-11.847,0-22.457-5.326-29.572-13.709c-5.721-6.751-9.174-15.498-9.174-25.036c0-21.396,17.35-38.746,38.746-38.746 S294.746,297.264,294.746,318.66z"
                ></path>{" "}
                <path
                  class="path"
                  style={{ fill: "#FFC26D" }}
                  d="M294.746,318.66c0,9.538-3.453,18.286-9.174,25.036L256,328.146l-29.572,15.55 c-5.721-6.751-9.174-15.498-9.174-25.036c0-21.396,17.35-38.746,38.746-38.746S294.746,297.264,294.746,318.66z"
                ></path>{" "}
                <g>
                  {" "}
                  <g>
                    {" "}
                    <path
                      class="path"
                      style={{ fill: "#FFCE8B" }}
                      d="M375.523,212.321l-50.52,49.229l11.925,69.529c1.784,10.413-9.139,18.346-18.499,13.437 L256,311.697l-62.429,32.82c-9.36,4.909-20.283-3.024-18.499-13.437l6.455-37.644l5.47-31.885l-50.52-49.229 c-7.56-7.372-3.38-20.232,7.067-21.744l69.801-10.141l31.223-63.261c4.672-9.479,18.193-9.479,22.865,0l31.223,63.261 l23.256,3.38l46.545,6.761C378.904,192.089,383.083,204.949,375.523,212.321z"
                    ></path>{" "}
                    <path
                      class="path"
                      style={{ fill: "#FFB54E" }}
                      d="M375.523,212.321l-50.52,49.229l11.925,69.529c1.784,10.413-9.139,18.346-18.499,13.437 L256,311.697l-62.429,32.82c-9.36,4.909-20.283-3.024-18.499-13.437l6.455-37.644c96.879-17.684,129.597-70.871,140.384-109.62 l46.545,6.761C378.904,192.089,383.083,204.949,375.523,212.321z"
                    ></path>{" "}
                  </g>{" "}
                </g>{" "}
              </g>{" "}
              <path
                class="path"
                style={{ fill: "#FFCE8B" }}
                d="M316.961,392.959H195.039c-4.268,0-7.726-3.459-7.726-7.726s3.459-7.726,7.726-7.726h121.922 c4.268,0,7.726,3.459,7.726,7.726S321.228,392.959,316.961,392.959z"
              ></path>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
      title: "Awards & Recognitions",
    },
  ];

  return (
  //   <section
  //   className="wrapper image-wrapper"
  //   style={{
  //     backgroundImage:
  //       `url(${tech})`,
       
  //   }}
  // >
        <div className="container py-5 py-md-5">
          <div className="row card-container-carrier">
          {CardData.map((card) => (
                <div className="col-xl-3 col-lg-3 col-md-6" key={card.id}>
                  <div className="card height-card-carrier CardContents">
                    <div className="card-body">
                    <div className="img1 equal-size">{card.svg}</div>
                    <h5 className="title">{card.title} </h5>
                </div>
                </div>
                </div>
          ))}
          </div>
        </div>
    // </section>
  );
}

export default CardCar;

